/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, February 2022
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import { scroller } from "react-scroll";
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug';
import EmptyFileDownloader from '../../components/EmptyFileDownloader';
import { PanelStyle } from '../../constants';
import { DecisionContainer, PersonalDataContainer, CheckableDecisionContainer } from '../../containers';
import { isMobileView, isTabletView, renderHelpDesc } from '../../components/utils/utils';
import AttachmentsPanel from '../../components/AttachmentsPanel';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import _ from 'lodash';
import fetch from '../../core/fetch';
import loadingData from './loading';

import v from './validators';

const {
  leftCol,
  labelCol,
  inputCol,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
} = PanelStyle;

const marginLeft = '40px';
const marginBottom = '20px';
const marginTop = '100px'; 

const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const checkBoxStyle = {
  transform: 'scale(1.5)', 
};

const YesNoOptions = [
  {
    label: 'TAK',
    value: 'TAK',
    disable: false,
  },
  {
    label: 'NIE',
    value: 'NIE',
    disable: false,
  },
];

const AddressFormDict = {
  AddressCity: {
    label: 'Miejscowość*',
    editable: true,
  },
  AddressZipCode: {
    label: 'Kod pocztowy*',
    editable: true,
  },
  AddressStreet: {
    label: 'Ulica*',
    editable: true,
  },
  AddressNumber: {
    label: 'Numer budynku*',
    editable: true,
  },
};

const UserFormDict = {
  UserCountry: {
    label: 'Kraj',
    editable: true,
  },
  UserVoivodeship: {
    label: 'Województwo',
    editable: true,
  },
  UserEpuap: {
    label: 'Adres skrytki ePUAP lub adres do doręczeń elektronicznych',
    editable: true,
  },
  UserOwner: {
    label: 'Czy wnioskodawca jest właścicielem lub użytkownikiem wieczystym?',
    editable: true,
    type: 'YesOrNo',
    options: YesNoOptions,
  },
};

const AgentDict = {
  AgentFirstName: {
    label: 'Imię',
    editable: true,
  },
  AgentFullName: {
    label: 'Nazwisko',
    editable: true,
  },
  AgentCompanyName: {
    label: 'Nazwa wnioskodawcy',
    editable: true,
  },
  AgentCountry: {
    label: 'Kraj',
    editable: true,
  },
  AgentVoivodeship: {
    label: 'Województwo',
    editable: true,
  },
  AgentDistrict: {
    label: 'Powiat',
    editable: true,
  },
  AgentCommunity: {
    label: 'Gmina',
    editable: true,
  },
  AgentAddressCity: {
    label: 'Miejscowość',
    editable: true,
  },
  AgentAddressStreet: {
    label: 'Ulica',
    editable: true,
  },
  AgentAddressNumber: {
    label: 'Nr budynku',
    editable: true,
  },
  AgentAddressFlat: {
    label: 'Nr lokalu',
    editable: true,
  },
  AgentAddressZipCode: {
    label: 'Kod pocztowy',
    editable: true,
  },
  AgentEmail: {
    label: 'Email',
    editable: true,
  },
  AgentPhoneNumber: {
    label: 'Telefon',
    editable: true,
  },
  AgentEpuap: {
    label: 'Adres skrytki ePUAP lub adres do doręczeń elektronicznych',
    editable: true,
  },
};

const isPartOptions = [
  {
    label: 'Teren inwestycji obejmuje całą działkę ewidencyjną lub działki ewidencyjne.',
    value: 'NIE',
    state: 'isPart',
  },
  {
    label: 'Teren inwestycji obejmuje część działki ewidencyjnej lub działek ewidencyjnych.**',
    value: 'TAK',
    state: 'isPart',
  },
];

const objectWorksOptions = [
  {
    label: 'budowa',
    value: 'budowa',
    state: 'objectWork',
  },
  {
    label: 'odbudowa',
    value: 'odbudowa',
    state: 'objectWork',
  },
  {
    label: 'rozbudowa',
    value: 'rozbudowa',
    state: 'objectWork',
  },
  {
    label: 'nadbudowa',
    value: 'nadbudowa',
    state: 'objectWork',
  },
  {
    label: 'przebudowa',
    value: 'przebudowa',
    state: 'objectWork',
  },
  {
    label: 'zmiana sposobu użytkowania',
    value: 'zmiana sposobu użytkowania',
    state: 'objectWork',
  },
  {
    label: 'inne',
    value: 'inne',
    state: 'objectWork',
  },
];

const publicRoadOptions = [
  {
    label: 'Nie dotyczy',
    state: 'publicRoadRefers',
  },
  {
    label: 'bezpośredni',
    state: 'publicRoadDirect',
  },
  {
    label: 'pośredni (droga wewnętrzna)*',
    state: 'publicRoadInternal',
  },
  {
    label: 'pośredni (służebność)*',
    state: 'publicRoadServitude',
  },
];

const waterworksOptions = [
  {
    label: '',
    state: 'waterworksActual',
  },
  {
    label: '',
    state: 'waterworksProjected',
  },
];

const wellOptions = [
  {
    label: '',
    state: 'wellActual',
  },
  {
    label: '',
    state: 'wellProjected',
  },
];

const otherWaterOptions = [
  {
    label: '',
    state: 'otherWaterActual',
  },
  {
    label: '',
    state: 'otherWaterProjected',
  },
];

const water2Disable = [
  'waterworksActual',
  'waterworksProjected',
  'wellActual',
  'wellProjected',
  'otherWaterActual',
  'otherWaterProjected',
];

const networkConnectionOptions = [
  {
    label: '',
    state: 'networkConnectionActual',
  },
  {
    label: '',
    state: 'networkConnectionProjected',
  },
];

const drainlessTankOptions = [
  {
    label: '',
    state: 'drainlessTankActual',
  },
  {
    label: '',
    state: 'drainlessTankProjected',
  },
];

const treatmentOptions = [
  {
    label: '',
    state: 'treatmentActual',
  },
  {
    label: '',
    state: 'treatmentProjected',
  },
];

const otherSewageOptions = [
  {
    label: '',
    state: 'otherSewageActual',
  },
  {
    label: '',
    state: 'otherSewageProjected',
  },
];

const sewage2Disable = [
  'networkConnectionActual',
  'networkConnectionProjected',
  'drainlessTankActual',
  'drainlessTankProjected',
  'treatmentActual',
  'treatmentProjected',
  'otherSewageActual',
  'otherSewageProjected',
]

const sewageConnectionOptions = [
  {
    label: '',
    state: 'sewageConnectionActual',
  },
  {
    label: '',
    state: 'sewageConnectionProjected',
  },
];

const drainlessSewegeTankOptions = [
  {
    label: '',
    state: 'drainlessSewegeTankActual',
  },
  {
    label: '',
    state: 'drainlessSewegeTankProjected',
  },
];

const individualSewageTankOptions = [
  {
    label: '',
    state: 'individualSewageActual',
  },
  {
    label: '',
    state: 'individualSewageProjected',
  },
];

const animalWastewaterOptions = [
  {
    label: '',
    state: 'animalWastewaterActual',
  },
  {
    label: '',
    state: 'animalWastewaterProjected',
  },
];

const manurePlateOptions = [
  {
    label: '',
    state: 'manurePlateActual',
  },
  {
    label: '',
    state: 'manurePlateProjected',
  },
];

const otherOtherSewageOptions = [
  {
    label: '',
    state: 'otherOtherSewageActual',
  },
  {
    label: '',
    state: 'otherOtherSewageProjected',
  },
];

const otherSewage2Disable = [
  'sewageConnectionActual',
  'sewageConnectionProjected',
  'drainlessSewegeTankActual',
  'drainlessSewegeTankProjected',
  'individualSewageActual',
  'individualSewageProjected',
  'animalWastewaterActual',
  'animalWastewaterProjected',
  'manurePlateActual',
  'manurePlateProjected',
  'otherOtherSewageActual',
  'otherOtherSewageProjected',
];

const rainwaterDrainageOptions = [
  {
    label: '',
    state: 'rainwaterDrainageActual',
  },
  {
    label: '',
    state: 'rainwaterDrainageProjected',
  },
];

const unpavedInvestmentAreaOptions = [
  {
    label: '',
    state: 'unpavedInvestmentAreaActual',
  },
  {
    label: '',
    state: 'unpavedInvestmentAreaProjected',
  },
];

const retentionReservoirsOptions = [
  {
    label: '',
    state: 'retentionReservoirsActual',
  },
  {
    label: '',
    state: 'retentionReservoirsProjected',
  },
];

const otherSnowmeltDrainageOptions = [
  {
    label: '',
    state: 'otherSnowmeltDrainageActual',
  },
  {
    label: '',
    state: 'otherSnowmeltDrainageProjected',
  },
];

const snowmelt2Disable = [
  'rainwaterDrainageActual',
  'rainwaterDrainageProjected',
  'unpavedInvestmentAreaActual',
  'unpavedInvestmentAreaProjected',
  'retentionReservoirsActual',
  'retentionReservoirsProjected',
  'otherSnowmeltDrainageActual',
  'otherSnowmeltDrainageProjected',
];

const electricityNetworkConnectionOptions = [
  {
    label: '',
    state: 'electricityNetworkConnectionActual',
  },
  {
    label: '',
    state: 'electricityNetworkConnectionProjected',
  },
];

const renewableSourcesOptions = [
  {
    label: '',
    state: 'renewableSourcesActual',
  },
  {
    label: '',
    state: 'renewableSourcesProjected',
  },
];

const otherElectricityOptions = [
  {
    label: '',
    state: 'otherElectricityActual',
  },
  {
    label: '',
    state: 'otherElectricityProjected',
  },
];

const electricity2Disable = [
  'electricityNetworkConnectionActual',
  'electricityNetworkConnectionProjected',
  'renewableSourcesActual',
  'renewableSourcesProjected',
  'otherElectricityActual',
  'otherElectricityProjected',
];

const gasConnectionOptions = [
  {
    label: '',
    state: 'gasConnectionActual',
  },
  {
    label: '',
    state: 'gasConnectionProjected',
  },
];

const abovegroundLPGTankOptions = [
  {
    label: '',
    state: 'abovegroundLPGTankActual',
  },
  {
    label: '',
    state: 'abovegroundLPGTankProjected',
  },
];

const undergroundLPGTankOptions = [
  {
    label: '',
    state: 'undergroundLPGTankActual',
  },
  {
    label: '',
    state: 'undergroundLPGTankProjected',
  },
];

const otherGasOptions = [
  {
    label: '',
    state: 'otherGasActual',
  },
  {
    label: '',
    state: 'otherGasProjected',
  },
];

const gas2Disable = [
  'gasConnectionActual',
  'gasConnectionProjected',
  'abovegroundLPGTankActual',
  'abovegroundLPGTankProjected',
  'undergroundLPGTankActual',
  'undergroundLPGTankProjected',
  'otherGasActual',
  'otherGasProjected',
];

const heatConnectionOptions = [
  {
    label: '',
    state: 'heatConnectionActual',
  },
  {
    label: '',
    state: 'heatConnectionProjected',
  },
];

const individualHeatSourceOptions = [
  {
    label: '',
    state: 'individualHeatSourceActual',
  },
  {
    label: '',
    state: 'individualHeatSourceProjected',
  },
];

const renewableHeatSourceOptions = [
  {
    label: '',
    state: 'renewableHeatSourceActual',
  },
  {
    label: '',
    state: 'renewableHeatSourceProjected',
  },
];

const otherHeatSourceOptions = [
  {
    label: '',
    state: 'otherHeatActual',
  },
  {
    label: '',
    state: 'otherHeatProjected',
  },
];

const heat2Disable = [
  'heatConnectionActual',
  'heatConnectionProjected',
  'individualHeatSourceActual',
  'individualHeatSourceProjected',
  'renewableHeatSourceActual',
  'renewableHeatSourceProjected',
  'otherHeatActual',
  'otherHeatProjected',
];

const wasteRulesOptions = [
  {
    label: '',
    state: 'wasteRulesActual',
  },
  {
    label: '',
    state: 'wasteRulesProjected',
  },
];

const otherWasteOptions = [
  {
    label: '',
    state: 'otherWasteActual',
  },
  {
    label: '',
    state: 'otherWasteProjected',
  },
];

const waste2Disable = [
  'wasteRulesActual',
  'wasteRulesProjected',
  'otherWasteActual',
  'otherWasteProjected',
];

const connectionNetworksOptions = [
  {
    label: '',
    state: 'connectionNetworksActual',
  },
  {
    label: '',
    state: 'connectionNetworksProjected',
  },
];

const connectionNetworks2Disable = [
  'connectionNetworksActual',
  'connectionNetworksProjected',
];

const buildingWorksOptions = [
  {
    label: 'budowa',
    value: 'budowa',
    state: 'buildWork',
  },
  {
    label: 'odbudowa',
    value: 'odbudowa',
    state: 'buildWork',
  },
  {
    label: 'rozbudowa',
    value: 'rozbudowa',
    state: 'buildWork',
  },
  {
    label: 'nadbudowa',
    value: 'nadbudowa',
    state: 'buildWork',
  },
  {
    label: 'przebudowa',
    value: 'przebudowa',
    state: 'buildWork',
  },
  {
    label: 'zmiana sposobu użytkowania',
    value: 'zmiana sposobu użytkowania',
    state: 'buildWork',
  },
  {
    label: 'inne',
    value: 'inne',
    state: 'buildWork',
  },
];


const objectTypeOptions = [
  {
    label: 'budowla',
    state: 'objectType1',
    type: 'checkbox',
  },
  {
    label: 'urządzenie wodne',
    state: 'objectType2',
    type: 'checkbox',
  },
  {
    label: 'inne',
    state: 'objectType3',
    type: 'checkbox',
  },
  {
    label: 'inne',
    state: 'objectTypeOther',
    type: 'textarea',
  },
];

const objectTypeOptions4Checkbox = [
  {
    label: '',
    state: 'objectType1',
  },
  {
    label: '',
    state: 'objectType2',
  },
  {
    label: '',
    state: 'objectType3',
  },
];

const investmentClassificationOptions = [
  {
    label: 'Zakład o zwiększonym ryzyku wystąpienia poważnej awarii przemysłowej',
    state: 'investmentClassificationType1',
    type: 'checkbox',
  },
  {
    label: 'Zakład o dużym ryzyku wystąpienia poważnej awarii przemysłowej',
    state: 'investmentClassificationType2',
    type: 'checkbox',
  },
];

const investmentClassificationOptions4Checkbox = [
  {
    label: '',
    state: 'investmentClassificationType1',
  },
  {
    label: '',
    state: 'investmentClassificationType2',
  },
];

const areaOptions = [
  {
    label: 'TAK',
    state: 'areaType1',
    type: 'checkbox',
  },
  {
    label: 'NIE',
    state: 'areaType2',
    type: 'checkbox',
  },
];

const areaOptions4Checkbox = [
  {
    label: '',
    state: 'areaType1',
  },
  {
    label: '',
    state: 'areaType2',
  },
];


const atticTypeOptions = [
  {
    label: 'użytkowe',
    state: 'atticType1',
    type: 'checkbox',
  },
  {
    label: 'nieużytkowe',
    state: 'atticType2',
    type: 'checkbox',
  },
  {
    label: 'nie dotyczy',
    state: 'atticType3',
    type: 'checkbox',
  },
];

const roofSlopeOptions = [
  {
    label: 'Symetryczny',
    state: 'roofSlope1',
    type: 'checkbox',
  },
  {
    label: 'Bez zmian',
    state: 'roofSlope2',
    type: 'checkbox',
  },
  {
    label: 'Inny',
    state: 'roofSlope3',
    type: 'checkbox',
  },
];

const ridgeTypeOptions = [
  {
    label: 'Prostopadły',
    state: 'ridgeType1',
    type: 'checkbox',
  },
  {
    label: 'Równoległy',
    state: 'ridgeType2',
    type: 'checkbox',
  },
  {
    label: 'Bez zmian',
    state: 'ridgeType3',
    type: 'checkbox',
  },
  {
    label: 'Inny',
    state: 'ridgeType4',
    type: 'checkbox',
  },
];

const distanceToBorderOptions = [
  {
    label: '4 m i więcej',
    state: 'distanceToBorder1',
    type: 'checkbox',
  },
  {
    label: 'mniej niż 4 m',
    state: 'distanceToBorder2',
    type: 'checkbox',
  },
];

const distanceWallsToBorderOptions = [
  {
    label: '3 m i więcej',
    state: 'distanceWallsToBorder1',
    type: 'checkbox',
  },
  {
    label: 'mniej niż 3 m',
    state: 'distanceWallsToBorder2',
    type: 'checkbox',
  },
];

const roofTypeOptions = [
  {
    label: 'Płaski',
    value: 'Płaski',
    state: 'roofType',
  },
  {
    label: 'Jednospadowy',
    value: 'Jednospadowy',
    state: 'roofType',
  },
  {
    label: 'Dwuspadowy',
    value: 'Dwuspadowy',
    state: 'roofType',
  },
  {
    label: 'Czterospadowy',
    value: 'Czterospadowy',
    state: 'roofType',
  },
  {
    label: 'Wielospadowy',
    value: 'Wielospadowy',
    state: 'roofType',
  },
  {
    label: 'Bez zmian',
    value: 'Bez zmian',
    state: 'roofType',
  },
  {
    label: 'Inny',
    value: 'Inny',
    state: 'roofType',
  },
];

const InvestCharacteristicsDict = {
  Name: {
    label: 'Nazwa inwestycji',
    editable: true,
  },
  InvestArea: {
    label: 'Powierzchnia terenu inwestycji w m2',
    editable: true,
  },
  ActualBuildings: {
    label: 'W przypadku gdy inwestycja dotyczy istniejącej zabudowy i zagospodarowania terenu, istniejąca zabudowa',
    editable: true,
    type: 'textarea',
  },
  ActualLandDevelop: {
    label: 'Obecny sposób zagospodarowania terenu inwestycji*',
    editable: true,
    type: 'textarea',
  },
  ProjectedLandDevelop: {
    label: 'Projektowany sposób zagospodarowania terenu inwestycji*',
    editable: true,
    type: 'textarea',
  },
};

const LandDict = {
  WayOfImpact: {
    label: 'Sposób oddziaływania, w przypadku gdy obszar oddziaływania obiektu wykracza poza teren inwestycji',
    editable: true,
    type: 'expandedtextarea',
  },
  EnvironmentImpact: {
    label: 'Dane charakteryzujące wpływ inwestycji na środowisko, w szczególności określenie rodzaju przedsięwzięcia w nawiązaniu do przepisów odrębnych, w przypadku gdy inwestycja zalicza się do przedsięwzięć mogących znacząco oddziaływać na środowisko',
    editable: true,
    type: 'expandedtextarea',
  },
  TwoFloorsHouse: {
    label: 'Inwestycja dotyczy wolnostojącego, nie więcej niż dwukondygnacyjnego budynku mieszkalnego jednorodzinnego o powierzchni zabudowy do 70 m², o którym mowa w art. 29 ust. 1 pkt 1a ustawy z dnia 7 lipca 1994 r. – Prawo budowlane (Dz. U. z 2023 r. poz. 682, z późn. zm.)',
    editable: true,
    type: 'YesOrNo',
    options: YesNoOptions,
  },
  BiogasPlant: {
    label: 'Inwestycja dotyczy biogazowni rolniczej spełniającej warunki określone w art. 4 ust. 1 ustawy z dnia 13 lipca 2023 r. o ułatwieniach w przygotowaniu i realizacji inwestycji w zakresie biogazowni rolniczych, a także ichfunkcjonowaniu (Dz. U. poz. 1597)',
    editable: true,
    type: 'YesOrNo',
    options: YesNoOptions,
  },
  StrategicInvestment: {
    label: 'Inwestycja dotyczy strategicznej inwestycji w zakresie sieci dystrybucyjnej, o której mowa w art. 1 ust. 2 pkt 4a ustawy z dnia 24 lipca 2015 r. o przygotowaniu i realizacji strategicznych inwestycji w zakresie sieci przesyłowych (Dz. U. z 2023 r. poz. 1680, z późn. zm.)',
    editable: true,
    type: 'YesOrNo',
    options: YesNoOptions,
  },
  HighRiskInvestment: {
    label: 'Inwestycja dotyczy zakładu o zwiększonym lub dużym ryzyku wystąpienia poważnej awarii przemysłowej, o którym mowa w art. 248 ust. 1 ustawy z dnia 27 kwietnia 2001 r. – Prawo ochrony środowiska (Dz. U. z 2024 r. poz. 54) (w przypadku zaznaczenia tej opcji należy uzupełnić załącznik E)',
    editable: true,
    type: 'YesOrNo',
    options: YesNoOptions,
  },
  SellingArea: {
    label: 'Łączna powierzchnia sprzedaży w metrach kwadratowych, w przypadku gdy inwestycja dotyczy obiektu handlowego',
    editable: true,
    type: 'expandedinput',
  },
  FarmArea: {
    label: 'Powierzchnia gospodarstwa rolnego w metrach kwadratowych, w przypadku gdy inwestycja jest związana z gospodarstwem rolnym',
    editable: true,
    type: 'expandedinput',
  },
  AdditionalLandInfo: {
    label: 'Dodatkowe informacje dotyczące terenu inwestycji:*',
    editable: true,
    type: 'expandedtextarea',
  },
};

const attachmentAFields2Validate = [
  {
    state: 'waterNeeds',
    validators: [v.NotNull],
    dependedOn: 'waterAccessRefers',
  },
  {
    state: 'sewageNeeds',
    validators: [v.NotNull],
    dependedOn: 'sewageRefers',
  },
  {
    state: 'otherSewageNeeds',
    validators: [v.NotNull],
    dependedOn: 'otherSewageRefers',
  },
  {
    state: 'snowmeltDrainageNeeds',
    validators: [v.NotNull],
    dependedOn: 'snowmeltDrainageRefers',
  },
  {
    state: 'electricityNeeds',
    validators: [v.NotNull],
    dependedOn: 'electricityRefers',
  },
  {
    state: 'gasNeeds',
    validators: [v.NotNull],
    dependedOn: 'gasRefers',
  },
  {
    state: 'heatNeeds',
    validators: [v.NotNull],
    dependedOn: 'heatRefers',
  },
  {
    state: 'wasteManagementNeeds',
    validators: [v.NotNull],
    dependedOn: 'wasteManagementRefers',
  },
  {
    state: 'connectionNetworksNeeds',
    validators: [v.NotNull],
    dependedOn: 'connectionNetworksRefers',
  },
  {
    state: 'otherTechInfo',
    validators: [v.NotNull],
    dependedOn: null,
  },
];

const buildingsAreaStates2Validate = ['buildingsAreaActual', 'buildingsAreaPredictedMin', 'buildingsAreaPredictedMax'];

const buildingsAreaCheckbox = {
  state: 'buildingsAreaRefers',
  validators: [v.isNumber, v.NotNull],
}
const buildingsAreaInputs = [
  {state: 'buildingsAreaActual'},
  {state: 'buildingsAreaPredictedMin'},
  {state: 'buildingsAreaPredictedMax'},
];

const biologicalSurfaceStates2Validate = ['biologicalSurfaceActual', 'biologicalSurfacePredictedMin', 'biologicalSurfacePredictedMax'];

const biologicalSurfaceCheckbox = {
  state: 'biologicalSurfaceRefers',
  validators: [v.isNumber, v.NotNull],
}
const biologicalSurfaceInputs = [
  {state: 'biologicalSurfaceActual'},
  {state: 'biologicalSurfacePredictedMin'},
  {state: 'biologicalSurfacePredictedMax'},
];

const transformationSurfaceStates2Validate = ['transformationSurfaceActual', 'transformationSurfacePredictedMin', 'transformationSurfacePredictedMax'];

const transformationSurfaceCheckbox = {
  state: 'transformationSurfaceRefers',
  validators: [v.isNumber, v.NotNull],
}
const transformationSurfaceInputs = [
  {state: 'transformationSurfaceActual'},
  {state: 'transformationSurfacePredictedMin'},
  {state: 'transformationSurfacePredictedMax'},
];

const frontFacadeWidthStates2Validate = ['frontFacadeActual', 'frontFacadePredictedMin', 'frontFacadePredictedMax'];

const frontFacadeWidthCheckbox = {
  state: 'frontFacadeRefers',
  validators: [v.isNumber],
}
const frontFacadeWidthInputs = [
  {state: 'frontFacadeActual'},
  {state: 'frontFacadePredictedMin'},
  {state: 'frontFacadePredictedMax'},
];

const overgroundStoreysAreaCountStates2Validate = ['overgroundStoreysAreaCountActual', 'overgroundStoreysAreaCountPredictedMin', 'overgroundStoreysAreaCountPredictedMax'];

const overgroundStoreysAreaCountCheckbox = {
  state: 'overgroundStoreysAreaCountRefers',
  validators: [v.isNumber],
}
const overgroundStoreysAreaCountInputs = [
  {state: 'overgroundStoreysAreaCountActual'},
  {state: 'overgroundStoreysAreaCountPredictedMin'},
  {state: 'overgroundStoreysAreaCountPredictedMax'},
];

const overgroundStoreysStates2Validate = ['overgroundStoreysActual', 'overgroundStoreysPredictedMin', 'overgroundStoreysPredictedMax'];

const overgroundStoreysCheckbox = {
  state: 'overgroundStoreysRefers',
  validators: [v.isNumber],
}
const overgroundStoreysInputs = [
  {state: 'overgroundStoreysActual'},
  {state: 'overgroundStoreysPredictedMin'},
  {state: 'overgroundStoreysPredictedMax'},
];

const undergroundStoreysAreaCountStates2Validate = ['undergroundStoreysAreaCountActual', 'undergroundStoreysAreaCountPredictedMin', 'undergroundStoreysAreaCountPredictedMax'];

const undergroundStoreysAreaCountCheckbox = {
  state: 'undergroundStoreysAreaCountRefers',
  validators: [v.isNumber],
}
const undergroundStoreysAreaCountInputs = [
  {state: 'undergroundStoreysAreaCountActual'},
  {state: 'undergroundStoreysAreaCountPredictedMin'},
  {state: 'undergroundStoreysAreaCountPredictedMax'},
];

const undergroundStoreysStates2Validate = ['undergroundStoreysActual', 'undergroundStoreysPredictedMin', 'undergroundStoreysPredictedMax'];

const undergroundStoreysCheckbox = {
  state: 'undergroundStoreysRefers',
  validators: [v.isNumber],
}
const undergroundStoreysInputs = [
  {state: 'undergroundStoreysActual'},
  {state: 'undergroundStoreysPredictedMin'},
  {state: 'undergroundStoreysPredictedMax'},
];

const mainRidgeHeightStates2Validate = ['mainRidgeHeightActual', 'mainRidgeHeightPredictedMin', 'mainRidgeHeightPredictedMax'];

const mainRidgeHeightCheckbox = {
  state: 'mainRidgeHeightRefers',
  validators: [v.isNumber],
}
const mainRidgeHeightInputs = [
  {state: 'mainRidgeHeightActual'},
  {state: 'mainRidgeHeightPredictedMin'},
  {state: 'mainRidgeHeightPredictedMax'},
];

const roofSlopeStates2Validate = ['roofSlopeActual', 'roofSlopePredictedMin', 'roofSlopePredictedMax'];

const roofSlopeCheckbox = {
  state: 'roofSlopeRefers',
  validators: [v.isNumber],
}
const roofSlopeInputs = [
  {state: 'roofSlopeActual'},
  {state: 'roofSlopePredictedMin'},
  {state: 'roofSlopePredictedMax'},
];

const objectAreaStates2Validate = ['objectAreaActual', 'objectAreaPredictedMin', 'objectAreaPredictedMax'];

const objectAreaCheckbox = {
  state: 'objectAreaRefers',
  validators: [v.isNumber],
}
const objectAreaInputs = [
  {state: 'objectAreaActual'},
  {state: 'objectAreaPredictedMin'},
  {state: 'objectAreaPredictedMax'},
];

const objectCapacityStates2Validate = ['objectCapacityActual', 'objectCapacityPredictedMin', 'objectCapacityPredictedMax'];

const objectCapacityCheckbox = {
  state: 'objectCapacityRefers',
  validators: [v.isNumber],
}
const objectCapacityInputs = [
  {state: 'objectCapacityActual'},
  {state: 'objectCapacityPredictedMin'},
  {state: 'objectCapacityPredictedMax'},
];

const objectLengthStates2Validate = ['objectLengthActual', 'objectLengthPredictedMin', 'objectLengthPredictedMax'];

const objectLengthCheckbox = {
  state: 'objectLengthRefers',
  validators: [v.isNumber],
}
const objectLengthInputs = [
  {state: 'objectLengthActual'},
  {state: 'objectLengthPredictedMin'},
  {state: 'objectLengthPredictedMax'},
];

const objectWidthStates2Validate = ['objectWidthActual', 'objectWidthPredictedMin', 'objectWidthPredictedMax'];

const objectWidthCheckbox = {
  state: 'objectWidthRefers',
  validators: [v.isNumber],
}
const objectWidthInputs = [
  {state: 'objectWidthActual'},
  {state: 'objectWidthPredictedMin'},
  {state: 'objectWidthPredictedMax'},
];

const objectHeigthStates2Validate = ['objectHeigthActual', 'objectHeigthPredictedMin', 'objectHeigthPredictedMax'];

const objectHeigthCheckbox = {
  state: 'objectHeigthRefers',
  validators: [v.isNumber],
}
const objectHeigthInputs = [
  {state: 'objectHeigthActual'},
  {state: 'objectHeigthPredictedMin'},
  {state: 'objectHeigthPredictedMax'},
];

const atticTypeOptions4Checkbox = [
  {
    label: '',
    state: 'atticType1',
  },
  {
    label: '',
    state: 'atticType2',
  },
  {
    label: '',
    state: 'atticType3',
  },
];

const roofSlopeOptions4Checkbox = [
  {
    label: '',
    state: 'roofSlope1',
  },
  {
    label: '',
    state: 'roofSlope2',
  },
  {
    label: '',
    state: 'roofSlope3',
  },
];

const ridgeTypeOptions4Checkbox = [
  {
    label: '',
    state: 'ridgeType1',
  },
  {
    label: '',
    state: 'ridgeType2',
  },
  {
    label: '',
    state: 'ridgeType3',
  },
  {
    label: '',
    state: 'ridgeType4',
  },
];

const distanceToBorderOptions4Checkbox = [
  {
    label: '',
    state: 'distanceToBorder1',
  },
  {
    label: '',
    state: 'distanceToBorder2',
  },
];

const distanceWallsToBorderOptions4Checkbox = [
  {
    label: '',
    state: 'distanceWallsToBorder1',
  },
  {
    label: '',
    state: 'distanceWallsToBorder2',
  },
];

const AttachmentADefaultState = {
  checked: false,

  waterAccessRefers: false,
  waterworksActual: false,
  waterworksProjected: false,
  wellActual: false,
  wellProjected: false,
  otherWaterActual: false,
  otherWaterProjected: false,
  waterNeeds: '',

  sewageRefers: false,
  networkConnectionActual: false,
  networkConnectionProjected: false,
  drainlessTankActual: false,
  drainlessTankProjected: false,
  treatmentActual: false,
  treatmentProjected: false,
  otherSewageActual: false,
  otherSewageProjected: false,
  sewageNeeds: '',

  otherSewageRefers: false,
  sewageConnectionActual: false,
  sewageConnectionProjected: false,
  drainlessSewegeTankActual: false,
  drainlessSewegeTankProjected: false,
  individualSewageActual: false,
  individualSewageProjected: false,
  animalWastewaterActual: false,
  animalWastewaterProjected: false,
  manurePlateActual: false,
  manurePlateProjected: false,
  otherOtherSewageActual: false,
  otherOtherSewageProjected: false,
  otherSewageNeeds: '',

  snowmeltDrainageRefers: false,
  rainwaterDrainageActual: false,
  rainwaterDrainageProjected: false,
  unpavedInvestmentAreaActual: false,
  unpavedInvestmentAreaProjected: false,
  retentionReservoirsActual: false,
  retentionReservoirsProjected: false,
  otherSnowmeltDrainageActual: false,
  otherSnowmeltDrainageProjected: false,
  snowmeltDrainageNeeds: '',

  electricityRefers: false,
  electricityNetworkConnectionActual: false,
  electricityNetworkConnectionProjected: false,
  renewableSourcesActual: false,
  renewableSourcesProjected: false,
  otherElectricityActual: false,
  otherElectricityProjected: false,
  electricityNeeds: '',

  gasRefers: false,
  gasConnectionActual: false,
  gasConnectionProjected: false,
  abovegroundLPGTankActual: false,
  abovegroundLPGTankProjected: false,
  undergroundLPGTankActual: false,
  undergroundLPGTankProjected: false,
  otherGasActual: false,
  otherGasProjected: false,
  gasNeeds: '',

  heatRefers: false,
  heatConnectionActual: false,
  heatConnectionProjected: false,
  individualHeatSourceActual: false,
  individualHeatSourceProjected: false,
  renewableHeatSourceActual: false,
  renewableHeatSourceProjected: false,
  otherHeatActual: false,
  otherHeatProjected: false,
  heatNeeds: '',

  wasteManagementRefers: false,
  wasteRulesActual: false,
  wasteRulesProjected: false,
  otherWasteActual: false,
  otherWasteProjected: false,
  wasteManagementNeeds: '',

  connectionNetworksRefers: false,
  connectionNetworksActual: false,
  connectionNetworksProjected: false,
  connectionNetworksNeeds: '',

  otherTechInfo: '',
};

const AttachmentBDefaultState = {
  checked: false,

  buildingName: '',
  buildingFunction: '',
  flatCountActual: '',
  flatCountProjected: '',

  buildWork: '',
  buildWorkOther: '',

  frontFacadeRefers: false,
  frontFacadeActual: '',
  frontFacadePredictedMin: '',
  frontFacadePredictedMax: '',

  overgroundStoreysAreaCountRefers: false,
  overgroundStoreysAreaCountActual: '',
  overgroundStoreysAreaCountPredictedMin: '',
  overgroundStoreysAreaCountPredictedMax: '',

  overgroundStoreysRefers: false,
  overgroundStoreysActual: '',
  overgroundStoreysPredictedMin: '',
  overgroundStoreysPredictedMax: '',

  undergroundStoreysAreaCountRefers: false,
  undergroundStoreysAreaCountActual: '',
  undergroundStoreysAreaCountPredictedMin: '',
  undergroundStoreysAreaCountPredictedMax: '',

  undergroundStoreysRefers: false,
  undergroundStoreysActual: '',
  undergroundStoreysPredictedMin: '',
  undergroundStoreysPredictedMax: '',

  mainRidgeHeightRefers: false,
  mainRidgeHeightActual: '',
  mainRidgeHeightPredictedMin: '',
  mainRidgeHeightPredictedMax: '',

  roofSlopeRefers: false,
  roofSlopeActual: '',
  roofSlopePredictedMin: '',
  roofSlopePredictedMax: '',

  atticType1: false,
  atticType2: false,
  atticType3: false,

  roofType: '',
  roofTypeAdditional: '',

  roofSlope1: false,
  roofSlope2: false,
  roofSlope3: false,
  roofSlopeAdditional: '',

  ridgeType1: false,
  ridgeType2: false,
  ridgeType3: false,
  ridgeType4: false,
  ridgeTypeAdditional: '',

  roofColorInfo: '',

  distanceToBorder1: false,
  distanceToBorder2: false,

  distanceWallsToBorder1: false,
  distanceWallsToBorder2: false,

  otherParams: '',
  sameBuildingsCount: '',
};

const AttachmentCDefaultState = {
  checked: false,

  nonBuildingName: '',

  objectType1: false,
  objectType2: false,
  objectType3: false,
  objectTypeOther: '',

  objectWork: '',
  objectWorkOther: '',

  objectAreaRefers: false,
  objectAreaActual: '',
  objectAreaPredictedMin: '',
  objectAreaPredictedMax: '',

  objectCapacityRefers: false,
  objectCapacityActual: '',
  objectCapacityPredictedMin: '',
  objectCapacityPredictedMax: '',

  objectLengthRefers: false,
  objectLengthActual: '',
  objectLengthPredictedMin: '',
  objectLengthPredictedMax: '',

  objectWidthRefers: false,
  objectWidthActual: '',
  objectWidthPredictedMin: '',
  objectWidthPredictedMax: '',

  objectHeigthRefers: false,
  objectHeigthActual: '',
  objectHeigthPredictedMin: '',
  objectHeigthPredictedMax: '',

  objectOtherParams: '',
  sameObjectsCount: '',
};

const AttachmentDDefaultState = {
  checked: false,

  landfillOrdinate: '',
  annualLandfilledWaste: '',
  wasteDepositedAmount: '',
  wastewaterMethod: '',
  landfillGasMethod: '',
  landfillOther: '',
};

const AttachmentEDefaultState = {
  checked: false,

  investmentClassificationType1: false,
  investmentClassificationType2: false,
  hazardousSubstances: '',
  areaType1: false,
  areaType2: false,
  areaInfo: '',
  additionalInfo: '',
};

const AgentDefaultState = {
  AddAgent: false,
  DeliveryAgent: false,
  AgentFirstName: '',
  AgentFullName: '',
  AgentCompanyName: '',
  AgentCountry: '',
  AgentVoivodeship: '',
  AgentDistrict: '',
  AgentCommunity: '',
  AgentAddressCity: '',
  AgentAddressStreet: '',
  AgentAddressNumber: '',
  AgentAddressFlat: '',
  AgentAddressZipCode: '',
  AgentEmail: '',
  AgentPhoneNumber: '',
  AgentEpuap: '',
}

const districtsToSkipMPZP = ['gmina_sulow'];


class DecyzjeWZ extends React.Component {
  state = {
    Agent: {
      AddAgent: false,
      DeliveryAgent: false,
      AgentFirstName: '',
      AgentFullName: '',
      AgentCompanyName: '',
      AgentCountry: '',
      AgentVoivodeship: '',
      AgentDistrict: '',
      AgentCommunity: '',
      AgentAddressCity: '',
      AgentAddressStreet: '',
      AgentAddressNumber: '',
      AgentAddressFlat: '',
      AgentAddressZipCode: '',
      AgentEmail: '',
      AgentPhoneNumber: '',
      AgentEpuap: '',
    },
    DecisionData: {
      AddressCity: '',
      AddressStreet: '',
      AddressNumber: '',
      AddressZipCode: '',

      UserCountry: '',
      UserVoivodeship: '',
      UserEpuap: '',
      UserOwner: 'TAK',
    },
    InvestCharacteristics: {
      isPart: 'NIE',
      Name: '',
      InvestArea: '',
      ActualBuildings: '',
      ActualLandDevelop: '',
      ProjectedLandDevelop: '',
      
      buildingsAreaRefers: false,
      buildingsAreaActual: '',
      buildingsAreaPredictedMin: '',
      buildingsAreaPredictedMax: '',

      biologicalSurfaceRefers: false,
      biologicalSurfaceActual: '',
      biologicalSurfacePredictedMin: '',
      biologicalSurfacePredictedMax: '',

      transformationSurfaceRefers: false,
      transformationSurfaceActual: '',
      transformationSurfacePredictedMin: '',
      transformationSurfacePredictedMax: '',

      WayOfImpact: '',
      EnvironmentImpact: '',
      TwoFloorsHouse: 'NIE',
      BiogasPlant: 'NIE',
      StrategicInvestment: 'NIE',
      HighRiskInvestment: 'NIE',
      SellingArea: '',
      FarmArea: '',
      AdditionalLandInfo: '',
    },
    Communication: {
      publicRoadRefers: false,
      publicRoadDirect: true,
      publicRoadInternal: false,
      publicRoadServitude: false,

      publicRoadAdditional: '',

      garageRefers: false,
      garageActual: '',
      garagePredictedMin: '',
      garagePredictedMax: '',

      parkingRefers: false,
      parkingActual: '',
      parkingPredictedMin: '',
      parkingPredictedMax: '',

      otherParkingRefers: false,
      otherParkingActual: '',
      otherParkingPredictedMin: '',
      otherParkingPredictedMax: '',

      parkingAdditional: '',
    },

    AttachmentA: AttachmentADefaultState,
    AttachmentB: AttachmentBDefaultState,
    AttachmentC: AttachmentCDefaultState,
    AttachmentD: AttachmentDDefaultState,
    AttachmentE: AttachmentEDefaultState,

    selectedParcels: [],
    selectedRoadParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null,
    attachments: null,
    loading: false,
    isMounted: false,
    mpzpValid: true,
  };

  elseString = '.....................';
  spanStyle = {
    color: 'red',
  };

  validators = {
    AgentFirstName: [],
    AgentFullName: [],
    AgentCompanyName: [],
    AgentCountry: [],
    AgentVoivodeship: [],
    AgentDistrict: [],
    AgentCommunity: [],
    AgentAddressCity: [],
    AgentAddressStreet: [],
    AgentAddressNumber: [],
    AgentAddressFlat: [],
    AgentAddressZipCode: [],
    AgentEmail: [],
    AgentPhoneNumber: [],
    AgentEpuap: [],

    AddressCity: [],
    AddressStreet: [],
    AddressNumber: [],
    AddressZipCode: [],

    UserCountry: [v.NotNull],
    UserVoivodeship: [v.NotNull],
    UserEpuap: [v.NotNull],

    Name: [v.NotNull],
    InvestArea: [v.NotNull, v.isNumber],
    ActualLandDevelop: [v.NotNull],
    ProjectedLandDevelop: [v.NotNull],

    buildingsAreaActual: [v.NotNull, v.isNumber],
    buildingsAreaPredictedMin: [v.NotNull, v.isNumber],
    buildingsAreaPredictedMax: [v.NotNull, v.isNumber],

    biologicalSurfaceActual: [v.NotNull, v.isNumber],
    biologicalSurfacePredictedMin: [v.NotNull, v.isNumber],
    biologicalSurfacePredictedMax: [v.NotNull, v.isNumber],

    transformationSurfaceActual: [v.NotNull, v.isNumber],
    transformationSurfacePredictedMin: [v.NotNull, v.isNumber],
    transformationSurfacePredictedMax: [v.NotNull, v.isNumber],

    publicRoadAdditional: [],

    garageActual: [v.NotNull, v.isStrictInteger],
    garagePredictedMin: [v.NotNull, v.isStrictInteger],
    garagePredictedMax: [v.NotNull, v.isStrictInteger],

    parkingActual: [v.NotNull, v.isStrictInteger],
    parkingPredictedMin: [v.NotNull, v.isStrictInteger],
    parkingPredictedMax: [v.NotNull, v.isStrictInteger],

    otherParkingActual: [v.NotNull, v.isStrictInteger],
    otherParkingPredictedMin: [v.NotNull, v.isStrictInteger],
    otherParkingPredictedMax: [v.NotNull, v.isStrictInteger],

    parkingAdditional: [],

    WayOfImpact: [],
    EnvironmentImpact: [],
    TwoFloorsHouse: [],
    BiogasPlant: [],
    StrategicInvestment: [],
    HighRiskInvestment: [],
    SellingArea: [v.isNumber],
    FarmArea: [v.isNumber],
    AdditionalLandInfo: [],

    waterNeeds: [],
    sewageNeeds: [],
    otherSewageNeeds: [],
    snowmeltDrainageNeeds: [],
    electricityNeeds: [],
    gasNeeds: [],
    heatNeeds: [],
    wasteManagementNeeds: [],
    connectionNetworksNeeds: [],
    otherTechInfo: [],

    flatCountActual: [v.isNumber],
    flatCountProjected: [v.isNumber],

    frontFacadeActual: [v.isNumber],
    frontFacadePredictedMin: [v.isNumber],
    frontFacadePredictedMax: [v.isNumber],

    overgroundStoreysAreaCountActual: [v.isNumber],
    overgroundStoreysAreaCountPredictedMin: [v.isNumber],
    overgroundStoreysAreaCountPredictedMax: [v.isNumber],

    overgroundStoreysActual: [v.isStrictInteger],
    overgroundStoreysPredictedMin: [v.isStrictInteger],
    overgroundStoreysPredictedMax: [v.isStrictInteger],

    undergroundStoreysAreaCountActual: [v.isNumber],
    undergroundStoreysAreaCountPredictedMin: [v.isNumber],
    undergroundStoreysAreaCountPredictedMax: [v.isNumber],

    undergroundStoreysActual: [v.isStrictInteger],
    undergroundStoreysPredictedMin: [v.isStrictInteger],
    undergroundStoreysPredictedMax: [v.isStrictInteger],

    mainRidgeHeightActual: [v.isNumber],
    mainRidgeHeightPredictedMin: [v.isNumber],
    mainRidgeHeightPredictedMax: [v.isNumber],

    roofSlopeActual: [v.isNumber],
    roofSlopePredictedMin: [v.isNumber],
    roofSlopePredictedMax: [v.isNumber],

    objectAreaActual: [v.isNumber],
    objectAreaPredictedMin: [v.isNumber],
    objectAreaPredictedMax: [v.isNumber],

    objectCapacityActual: [v.isNumber],
    objectCapacityPredictedMin: [v.isNumber],
    objectCapacityPredictedMax: [v.isNumber],

    objectLengthActual: [v.isNumber],
    objectLengthPredictedMin: [v.isNumber],
    objectLengthPredictedMax: [v.isNumber],

    objectWidthActual: [v.isNumber],
    objectWidthPredictedMin: [v.isNumber],
    objectWidthPredictedMax: [v.isNumber],

    objectHeigthActual: [v.isNumber],
    objectHeigthPredictedMin: [v.isNumber],
    objectHeigthPredictedMax: [v.isNumber],


  };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {

        this.setState({
          eserviceDistrict: resp, isMounted: true
        })
      })
  }

  onHide = () => this.setState({ showError: false });

  onCheckAgent = () => {
    const Agent = this.state.Agent;
    Agent.AddAgent = !this.state.Agent.AddAgent;
    this.setState({ Agent }, () => this.changeAgentvalidators());
  }

  onChangeCheckbox = (e, group, state) => {
    const checked = e.target.checked;

    this.setState((prevState) => ({
      [group]: {
        ...prevState[group],
        [state]: checked
      }
    }));
  };

  changeAgentvalidators = () => {
    if (this.state.Agent.AddAgent) {
      this.validators.AgentFirstName = [v.NotNull];
      this.validators.AgentFullName = [v.NotNull];
      this.validators.AgentCompanyName = [];
      this.validators.AgentCountry = [v.NotNull];
      this.validators.AgentVoivodeship = [v.NotNull];
      this.validators.AgentDistrict = [v.NotNull];
      this.validators.AgentCommunity = [v.NotNull];
      this.validators.AgentAddressCity = [v.NotNull];
      this.validators.AgentAddressStreet = [];
      this.validators.AgentAddressNumber = [v.NotNull];
      this.validators.AgentAddressFlat = [];
      this.validators.AgentAddressZipCode = [v.NotNull];
      this.validators.AgentEmail = [];
      this.validators.AgentPhoneNumber = [];
      this.validators.AgentEpuap = [v.NotNull];
    } else {
      this.validators.AgentFirstName = [];
      this.validators.AgentFullName = [];
      this.validators.AgentCompanyName = [];
      this.validators.AgentCountry = [];
      this.validators.AgentVoivodeship = [];
      this.validators.AgentDistrict = [];
      this.validators.AgentCommunity = [];
      this.validators.AgentAddressCity = [];
      this.validators.AgentAddressStreet = [];
      this.validators.AgentAddressNumber = [];
      this.validators.AgentAddressFlat = [];
      this.validators.AgentAddressZipCode = [];
      this.validators.AgentEmail = [];
      this.validators.AgentPhoneNumber = [];
      this.validators.AgentEpuap = [];
    }
  }

  changeValidators = (state, group, validatedFieldsList, validatorsList, reversedValidation = false) => {
    for (const field of validatedFieldsList) {
      if (reversedValidation) {
        if (this.state[group][state]) {
          this.validators[field] = validatorsList;
        } else {
          this.validators[field] = [];
        }
      } else {
        if (!this.state[group][state]) {
          this.validators[field] = validatorsList;
        } else {
          this.validators[field] = [];
        }
      }

    }
    this.validate(group, null, null);
    
  }

  changeLabeledValidators = (state, group, validatedFieldsList, validatorsList, states2Disable) => {
    let changeState = false;
    const stat = this.state[group];
    for (const field of validatedFieldsList) {
      if (this.state[group][state]) {
        this.validators[field] = validatorsList;
      } else {
        this.validators[field] = [];
      }
    }
    if (!this.state[group][state]) {
      changeState = true;
      for (const field of states2Disable) {
        stat[field] = false;
      }
    }
    if (changeState) {
      this.setState({
        [group]: stat
        }, () => this.validate(group, null, null));
    } else {
      this.validate(group, null, null);
    }
    
  }

  changeSpecifiedValidators = (state, group, validatedFieldsList, validatorsList) => {
    const stat = this.state[group];
    let changeState = false;
    for (const field of validatedFieldsList) {
      if (!this.state[group][state]) {
        this.validators[field] = validatorsList;
      } else {
        changeState = true;
        this.validators[field] = [];
        stat[field] = '';
      }
    }
    if (changeState) {
      this.setState({
        [group]: stat
        }, () => this.validate(group, null, null));
    } else {
      this.validate(group, null, null);
    }
  }

  changeAttachmentValidators = (state, group, validatorsList) => {
    for (const field of validatorsList) {
      if (this.state[group][state] && field.dependedOn && this.state[group][field.dependedOn]) {
        this.validators[field.state] = field.validators;
        this.validate(group, null, null);
      } else {
        this.validators[field.state] = [];
        // this.clearData(group);
      }
    }
    if (!this.state[group][state]) {
      this.clearData(group);
    }
  }

  mpzpValidator = (valid) => {

    if (valid !== this.state.mpzpValid) {

      this.setState({ mpzpValid: valid });

    }

  }

  clearData = (group) => {
    let newState = {};
    if (group === 'AttachmentA') {
      newState = AttachmentADefaultState;
    }
    if (group === 'AttachmentB') {
      newState = AttachmentBDefaultState;
    }
    if (group === 'AttachmentC') {
      newState = AttachmentCDefaultState;
    }
    if (group === 'AttachmentD') {
      newState = AttachmentDDefaultState;
    }
    this.setState({ [group]: newState }, () => this.validate(group, null, null));
  }

  unselectOthers = (state, group, otherCheckboxesList) => {
    if (this.state[group][state]) {
      const newState = this.state[group];
      for (const checkbox of otherCheckboxesList) {
        if (checkbox.state !== state) {
          newState[checkbox.state] = false;
        }
      }
      this.setState({ [group]: newState });
    }
  }

  onChangeLabeledCheckbox = (state, group, validatedFieldsList, validatorsList, states2Disable) => {
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [state]: !this.state[group][state],
        },
      },
      () => this.changeLabeledValidators(state, group, validatedFieldsList, validatorsList, states2Disable),
    );
  }

  onChangeSpecifiedCheckbox = (state, group, validatedFieldsList, validatorsList) => {
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [state]: !this.state[group][state],
        },
      },
      () => this.changeSpecifiedValidators(state, group, validatedFieldsList, validatorsList),
    );
  }

  onChangeAttachmentCheckbox = (state, group, validatorsList) => {
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [state]: !this.state[group][state],
        },
      },
      () => this.changeAttachmentValidators(state, group, validatorsList),
    );
  }

  onChangeCheckboxesRow = (state, group, otherCheckboxesList) => {
    let val = !this.state[group][state];
    let trueCount = 0;
    for (const checkbox of otherCheckboxesList) {
      if (checkbox.state === true) {
        trueCount += 1;
      }
    }
    if (trueCount === 0) {
      val = true;
    }
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [state]: val,
        },
      },
      () => this.unselectOthers(state, group, otherCheckboxesList),
    );
  }

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });
  setRoadParcels = (parcels, callback = null) => this.setState({ selectedRoadParcels: parcels });
  setRoads = (roads, callback = null) => this.setState({ selectedRoads: roads });


  getInputWithError = (description, group, field) => (
    <div style={{ textAlign: 'justify' }}>
      <b>{description}</b>
      <input
        className="form-control"
        name={field}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.errors).indexOf(field) > -1 &&
              this.state.errors[field] !== null &&
              this.state.errors[field].length > 0
              ? 'red'
              : '#ccc',
        }}
        value={this.state[group][field] ? this.state[group][field] : ''}
        onChange={e => this.onChange(e, group)}
      />
      {/* RENDER ERROS IN SPAN */}
      {Object.keys(this.state.errors).indexOf(field) > -1 &&
        this.state.errors[field] !== null &&
        this.state.errors[field].length > 0
        ? this.state.errors[field].map((val, index) => (
          <span key={index} style={errorSpanStyle}>
            {val}
          </span>
        ))
        : null}
    </div>
  )

  getTextAreaWithError = (description, group, field, marginLeft = null) => (
    <p style={{ textAlign: 'justify', marginTop: '20px', marginLeft: marginLeft }}>
      <b>{description}</b>
      <textarea
        name={field}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.errors).indexOf(field) > -1 &&
              this.state.errors[field] !== null &&
              this.state.errors[field].length > 0
              ? 'red'
              : '#ccc',
        }}
        className="form-control"
        rows={5}
        value={this.state[group][field] ? this.state[group][field] : ''}
        onChange={e => this.onChange(e, group)}
      />
      {/* RENDER ERROS IN SPAN */}
      {Object.keys(this.state.errors).indexOf(field) > -1 &&
        this.state.errors[field] !== null &&
        this.state.errors[field].length > 0
        ? this.state.errors[field].map((val, index) => (
          <span key={index} style={errorSpanStyle}>
            {val}
          </span>
        ))
        : null}
      <br />
    </p>
  )

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['Agent', 'DecisionData',  'Communication', 'InvestCharacteristics', 'AttachmentA', 'AttachmentB', 'AttachmentC', 'AttachmentD'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      Agent: {
        AddAgent: true,
        DeliveryAgent: true,
        AgentFirstName: 'Pelnomocnik Imię',
        AgentFullName: 'Pelnomocnik Nazwisko',
        AgentCompanyName: 'Pelnomocnik Nazwa',
        AgentCountry: 'Pelnomocnik Kraj',
        AgentVoivodeship: 'Pelnomocnik Woj',
        AgentDistrict: 'Pelnomocnik Powiat',
        AgentCommunity: 'Pelnomocnik Gmina',
        AgentAddressCity: 'Pelnomocnik Miasto',
        AgentAddressStreet: 'Pelnomocnik Ulica',
        AgentAddressNumber: 'Pelnomocnik NrBud',
        AgentAddressFlat: 'Pelnomocnik NrLok',
        AgentAddressZipCode: 'Pelnomocnik Kod',
        AgentEmail: 'Pelnomocnik Email',
        AgentPhoneNumber: 'Pelnomocnik Tel',
        AgentEpuap: 'Pelnomocnik ePUAP',
      },
      DecisionData: {
        AddressCity: 'Warszawa',
        AddressStreet: 'Koncertowa',
        AddressNumber: 6,
        AddressZipCode: '02-787',

        UserCountry: 'Polska',
        UserVoivodeship: 'lubelskie',
        UserEpuap: '/test/test',
        UserOwner: 'TAK',
      },
      InvestCharacteristics: {
        isPart: 'NIE',
        Name: 'Inw Nazwa',
        InvestArea: 1000,
        ActualBuildings: 'Inw akt. zabudowa',
        ActualLandDevelop: 'Inw akt. zagosp.',
        ProjectedLandDevelop: 'Inw proj. zagosp.',
        
        buildingsAreaRefers: false,
        buildingsAreaActual: 1,
        buildingsAreaPredictedMin: 2,
        buildingsAreaPredictedMax: 3,
  
        biologicalSurfaceRefers: false,
        biologicalSurfaceActual: 4,
        biologicalSurfacePredictedMin: 5,
        biologicalSurfacePredictedMax: 6,
  
        transformationSurfaceRefers: false,
        transformationSurfaceActual: 7,
        transformationSurfacePredictedMin: 8,
        transformationSurfacePredictedMax: 9,
  
        WayOfImpact: 'Inw sposób oddziaływania',
        EnvironmentImpact: 'Inw sposób oddziaływania na środowisko',
        TwoFloorsHouse: 'TAK',
        BiogasPlant: 'NIE',
        StrategicInvestment: 'NIE',
        HighRiskInvestment: 'NIE',
        SellingArea: 10,
        FarmArea: 11,
        AdditionalLandInfo: 'Inw dodat. inf.',
      },
      Communication: {
        publicRoadRefers: false,
        publicRoadDirect: true,
        publicRoadInternal: false,
        publicRoadServitude: false,
  
        publicRoadAdditional: 'Droga dod. info',
  
        garageRefers: false,
        garageActual: 12,
        garagePredictedMin: 13,
        garagePredictedMax: 14,
  
        parkingRefers: false,
        parkingActual: 15,
        parkingPredictedMin: 16,
        parkingPredictedMax: 17,
  
        otherParkingRefers: false,
        otherParkingActual: 18,
        otherParkingPredictedMin: 19,
        otherParkingPredictedMax: 20,
  
        parkingAdditional: 'Parking dod. info',
      },

      AttachmentA: {
        checked: true,
  
        waterAccessRefers: true,
        waterworksActual: true,
        waterworksProjected: false,
        wellActual: true,
        wellProjected: false,
        otherWaterActual: true,
        otherWaterProjected: false,
        waterNeeds: 'A1',
  
        sewageRefers: true,
        networkConnectionActual: true,
        networkConnectionProjected: false,
        drainlessTankActual: true,
        drainlessTankProjected: false,
        treatmentActual: true,
        treatmentProjected: false,
        otherSewageActual: true,
        otherSewageProjected: false,
        sewageNeeds: 'A2',
  
        otherSewageRefers: true,
        sewageConnectionActual: false,
        sewageConnectionProjected: true,
        drainlessSewegeTankActual: false,
        drainlessSewegeTankProjected: true,
        individualSewageActual: false,
        individualSewageProjected: true,
        animalWastewaterActual: false,
        animalWastewaterProjected: true,
        manurePlateActual: false,
        manurePlateProjected: true,
        otherOtherSewageActual: false,
        otherOtherSewageProjected: true,
        otherSewageNeeds: 'A3',
  
        snowmeltDrainageRefers: true,
        rainwaterDrainageActual: true,
        rainwaterDrainageProjected: false,
        unpavedInvestmentAreaActual: true,
        unpavedInvestmentAreaProjected: false,
        retentionReservoirsActual: true,
        retentionReservoirsProjected: false,
        otherSnowmeltDrainageActual: true,
        otherSnowmeltDrainageProjected: false,
        snowmeltDrainageNeeds: 'A4',
  
        electricityRefers: true,
        electricityNetworkConnectionActual: true,
        electricityNetworkConnectionProjected: false,
        renewableSourcesActual: true,
        renewableSourcesProjected: false,
        otherElectricityActual: true,
        otherElectricityProjected: false,
        electricityNeeds: 'A5',
  
        gasRefers: true,
        gasConnectionActual: true,
        gasConnectionProjected: false,
        abovegroundLPGTankActual: true,
        abovegroundLPGTankProjected: false,
        undergroundLPGTankActual: true,
        undergroundLPGTankProjected: false,
        otherGasActual: true,
        otherGasProjected: false,
        gasNeeds: 'A6',
  
        heatRefers: true,
        heatConnectionActual: true,
        heatConnectionProjected: false,
        individualHeatSourceActual: true,
        individualHeatSourceProjected: false,
        renewableHeatSourceActual: true,
        renewableHeatSourceProjected: false,
        otherHeatActual: true,
        otherHeatProjected: false,
        heatNeeds: 'A7',
  
        wasteManagementRefers: true,
        wasteRulesActual: false,
        wasteRulesProjected: true,
        otherWasteActual: false,
        otherWasteProjected: true,
        wasteManagementNeeds: 'A8',
  
        connectionNetworksRefers: true,
        connectionNetworksActual: false,
        connectionNetworksProjected: true,
        connectionNetworksNeeds: 'A9',
  
        otherTechInfo: 'A10',
      },

      AttachmentB: {
        checked: true,
  
        buildingName: 'Nazwa',
        buildingFunction: 'Funkcja',
        flatCountActual: 5,
        flatCountProjected: 10,
  
        buildWork: 'budowa',
        buildWorkOther: 'B1',
  
        frontFacadeRefers: false,
        frontFacadeActual: 21,
        frontFacadePredictedMin: 22,
        frontFacadePredictedMax: 23,

        overgroundStoreysAreaCountRefers: false,
        overgroundStoreysAreaCountActual: 24,
        overgroundStoreysAreaCountPredictedMin: 25,
        overgroundStoreysAreaCountPredictedMax: 26,
  
        overgroundStoreysRefers: false,
        overgroundStoreysActual: 24,
        overgroundStoreysPredictedMin: 25,
        overgroundStoreysPredictedMax: 26,

        undergroundStoreysAreaCountRefers: false,
        undergroundStoreysAreaCountActual: 24,
        undergroundStoreysAreaCountPredictedMin: 25,
        undergroundStoreysAreaCountPredictedMax: 26,
  
        undergroundStoreysRefers: false,
        undergroundStoreysActual: 27,
        undergroundStoreysPredictedMin: 28,
        undergroundStoreysPredictedMax: 29,
  
        mainRidgeHeightRefers: false,
        mainRidgeHeightActual: 33,
        mainRidgeHeightPredictedMin: 34,
        mainRidgeHeightPredictedMax: 35,
  
        roofSlopeRefers: false,
        roofSlopeActual: 36,
        roofSlopePredictedMin: 37,
        roofSlopePredictedMax: 38,
  
        atticType1: true,
        atticType2: false,
        atticType3: false,
  
        roofType: 'Dwuspadowy',
        roofTypeAdditional: 'B2',
  
        roofSlope1: true,
        roofSlope2: false,
        roofSlope3: false,
        roofSlopeAdditional: 'B3',
  
        ridgeType1: true,
        ridgeType2: false,
        ridgeType3: false,
        ridgeType4: false,
        ridgeTypeAdditional: 'B4',
  
        roofColorInfo: 'B5',
  
        distanceToBorder1: true,
        distanceToBorder2: false,
  
        distanceWallsToBorder1: true,
        distanceWallsToBorder2: false,
  
        otherParams: 'B6',
        sameBuildingsCount: 'B7',
      },

      AttachmentC: {
        checked: true,
  
        nonBuildingName: 'C1',
  
        objectType1: true,
        objectType2: false,
        objectType3: false,
        objectTypeOther: '',
  
        objectWork: 'budowa',
        objectWorkOther: '',
  
        objectAreaRefers: false,
        objectAreaActual: 39,
        objectAreaPredictedMin: 40,
        objectAreaPredictedMax: 41,
  
        objectCapacityRefers: false,
        objectCapacityActual: 42,
        objectCapacityPredictedMin: 43,
        objectCapacityPredictedMax: 44,
  
        objectLengthRefers: false,
        objectLengthActual: 45,
        objectLengthPredictedMin: 46,
        objectLengthPredictedMax: 46,
  
        objectWidthRefers: false,
        objectWidthActual: 47,
        objectWidthPredictedMin: 48,
        objectWidthPredictedMax: 49,
  
        objectHeigthRefers: false,
        objectHeigthActual: 50,
        objectHeigthPredictedMin: 51,
        objectHeigthPredictedMax: 52,
  
        objectOtherParams: 'C4',
        sameObjectsCount: 'C5',
      },
      AttachmentD: {
        checked: true,
  
        landfillOrdinate: 'D1',
        annualLandfilledWaste: 'D2',
        wasteDepositedAmount: 'D3',
        wastewaterMethod: 'D4',
        landfillGasMethod: 'D5',
        landfillOther: 'D6',
      },
      AttachmentE: {
        checked: true,

        investmentClassificationType1: true,
        investmentClassificationType2: false,
        hazardousSubstances: 'E1',
        areaType1: true,
        areaType2: false,
        areaInfo: 'E2',
        additionalInfo: 'E3',
      }
    });
  };

  validateAttachmentsContent = () => {
    if (this.state.attachments) {
      for (const attachment of this.state.attachments) {
        if (attachment.name.length < 1) return true;
      }
    }
    return false;
  }

  scrollToSection = (field) => {
    scroller.scrollTo(field, {
      duration: 500,
      delay: 100,
      smooth: true,
      offset: -400,
    });
  };

  validateAttachmentA = () => {
    const rowList = [
      {
        title: 'Dostęp do wody',
        statesList: [waterworksOptions, wellOptions, otherWaterOptions],
        checkbox: 'waterAccessRefers',
      },
      {
        title: 'Odprowadzenie ścieków',
        statesList: [networkConnectionOptions, drainlessTankOptions, treatmentOptions, otherSewageOptions],
        checkbox: 'sewageRefers',
      },
      {
        title: 'Utylizacja ścieków pozostałych',
        statesList: [sewageConnectionOptions, drainlessSewegeTankOptions, individualSewageTankOptions, animalWastewaterOptions, manurePlateOptions, otherOtherSewageOptions],
        checkbox: 'otherSewageRefers',
      },
      {
        title: 'Odprowadzenie wód opadowych i roztopowych',
        statesList: [rainwaterDrainageOptions, unpavedInvestmentAreaOptions, retentionReservoirsOptions, otherSnowmeltDrainageOptions],
        checkbox: 'snowmeltDrainageRefers',
      },
      {
        title: 'Dostęp do energii elektrycznej',
        statesList: [electricityNetworkConnectionOptions, renewableSourcesOptions, otherElectricityOptions],
        checkbox: 'electricityRefers',
      },
      {
        title: 'Dostęp do gazu',
        statesList: [gasConnectionOptions, abovegroundLPGTankOptions, undergroundLPGTankOptions, otherGasOptions],
        checkbox: 'gasRefers',
      },
      {
        title: 'Źródło ciepła',
        statesList: [heatConnectionOptions, individualHeatSourceOptions, renewableHeatSourceOptions, otherHeatSourceOptions],
        checkbox: 'heatRefers',
      },
      {
        title: 'Gospodarowanie odpadami',
        statesList: [wasteRulesOptions, otherWasteOptions],
        checkbox: 'wasteManagementRefers',
      },
      {
        title: 'Zaopatrzenie w środki łączności',
        statesList: [connectionNetworksOptions],
        checkbox: 'connectionNetworksRefers',
      },
    ];

    const state = this.state.AttachmentA;

    for (const row of rowList) {
      const place2Scroll = `AttachmentA_${row.checkbox}_TitleRow`;
      for (const option of row.statesList) {
        if (state[row.checkbox] && !state[option[0].state] && !state[option[1].state]) {
          this.scrollToSection(place2Scroll);
          return row.title;
        }
      }
    }

    return null;
  }

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej w sekcji "2. Teren objęty wnioskiem". Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      }, () => this.scrollToSection('CustomizedMap_1'));
      return;
    }

    if (this.state.mpzpValid && !districtsToSkipMPZP.includes(this.props.prefix)) {

      this.setState({
        errorText: 'Jedna lub więcej działek posiada pokrycie w MPZP.',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      }, () => this.scrollToSection('CustomizedMap_1'));

      return;

    }

    if (!this.state.Communication.publicRoadRefers && this.state.selectedRoadParcels.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej w sekcji "5. Obsługa komunikacyjna". Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      }, () => this.scrollToSection('CustomizedMap_2'));
      return;
    }

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
      return;
    }

    const errorField = this.validateAttachmentA();
    if (errorField) {
      this.setState({
        errorText: `W załączniku "A" w sekcji "${errorField}" nie wybrano opcji "Istniejące/Projektowane".`,
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!this.state.attachments || this.state.attachments.length === 0) {
      this.setState({
        errorText: 'Wymagane jest dodanie załączników do składanego wniosku',
        errorTitle: 'Brak załączników.',
        showError: true,
        loading: false,
      });
      return;
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!hasFieldErrors && this.state.selectedParcels.length > 0) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          Agent: this.state.Agent.AddAgent || this.state.Agent.DeliveryAgent ? {...this.state.Agent} : {...AgentDefaultState },
          DecisionData: { ...this.state.DecisionData },
          Communication: { ...this.state.Communication },
          InvestCharacteristics: { ...this.state.InvestCharacteristics },
          AttachmentA: { ...this.state.AttachmentA },
          AttachmentB: { ...this.state.AttachmentB },
          AttachmentC: { ...this.state.AttachmentC },
          AttachmentD: { ...this.state.AttachmentD },
          AttachmentE: { ...this.state.AttachmentE },
          selectedParcels: this.state.selectedParcels,
          selectedRoadParcels: this.state.selectedRoadParcels,
          user: {
            ...this.props.serviceInfo.user,
          },
          urzad: this.props.districts[this.props.prefix],
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.setState({
            loading: false }, () =>
            this.redirectToSummary(resp.jobId));
        });
    }
  };

  redirectToSummary = (jobId) => {
    window.location.href = `${this.nextStep}${jobId}`;
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  renderRadioButtons = (buttonsList, group, state) => {
    return (
      <div>
        {buttonsList.map((item, index) => (
          <div key={`radio${item}_${index}`} className="radio" style={{ marginBottom: '0px', marginTop: '0px' }}>
            <label
              // htmlFor={`radio${item}_${index}`}
              style={item.disabled ? { color: 'gray' } : null}
            >
              <input
                type="radio"
                value={item.value}
                name={state}
                checked={this.state[group][state] === item.value}
                onChange={e => this.onChange(e, group)}
                disabled={item.disabled}
              />
              <b>{`    ${item.label}`}<br /></b>
            </label>
          </div>
        ))}
      </div>);
  }

  renderSpecifiedDataRow = (title, states2Validate, group, checkboxData, inputsData, marginTop) => {
    return (
      <div style={{ marginTop: '20px' }}>
        <p style={{ marginLeft: marginLeft, marginBottom: marginBottom, marginTop: marginTop }}><b>{title}</b></p>
        {this.renderTitles('Nie dotyczy', 'Istniejąca', 'Projektowana - minimalna', 'Projektowana - maksymalna')}
        <div className='col-sm-12'>
          <div className='col-sm-3' style={{ textAlign: 'center' }}>
            {this.renderSpecifiedCheckbox(checkboxData.state, group, states2Validate, checkboxData.validators)}
          </div>
          {inputsData.map((item, index) => (
            <div className="col-sm-3" key={`SpecifiedData_${index}`}>
              {this.renderInput(item.state, group, checkboxData.state)}
            </div>
            ))
          }
        </div>
        <br />
      </div>);
  }

  renderTitles = (first, second, third, fourth) => {
    return (
      <div
        className='col-sm-12'
        style={{ textAlign: 'center' }}
      >
        <div className='col-sm-3'>
          <p><b>{first}</b></p>
        </div>
        <div className='col-sm-3'>
          <p><b>{second}</b></p>
        </div>
        <div className='col-sm-3'>
        <p><b>{third}</b></p>
        </div>
        <div className='col-sm-3'>
        <p><b>{fourth}</b></p>
        </div>
      </div>
    )
  }

  renderAttachmentETitles = (first, second, third, fourth) => {
    let count = 0;
    if (first) count += 1;
    if (second) count += 1;
    if (third) count += 1;
    if (fourth) count += 1;
    return (
      <div
        className='col-sm-12'
        style={{ textAlign: 'center' }}
      >
        <div className={`col-sm-${12 / count}`}>
          <p><b>{first}</b></p>
        </div>
        <div className={`col-sm-${12 / count}`}>
          <p><b>{second}</b></p>
        </div>
        <div className={`col-sm-${12 / count}`}>
        <p><b>{third}</b></p>
        </div>
        <div className={`col-sm-${12 / count}`}>
        <p><b>{fourth}</b></p>
        </div>
      </div>
    )
  }

  renderGarageRow = () => {
    const states = ['garageActual', 'garagePredictedMin', 'garagePredictedMax'];
    return (
      <div style={{ marginTop: '20px' }}>
        {this.renderTitles('Nie dotyczy', 'Istniejąca liczba miejsc do parkowania', 'Projektowana liczba miejsc do parkowania - minimalna', 'Projektowana liczba miejsc do parkowania - maksymalna')}
        <div className='col-sm-12'>
          <div className='col-sm-3' style={{ textAlign: 'center' }}>
            {this.renderSpecifiedCheckbox('garageRefers', 'Communication', states, [v.NotNull, v.isNumber])}
          </div>
          <div className='col-sm-3'>
            {this.renderInput('garageActual', 'Communication', 'garageRefers')}
          </div>
          <div className='col-sm-3'>
            {this.renderInput('garagePredictedMin', 'Communication', 'garageRefers')}
          </div>
          <div className='col-sm-3'>
          {this.renderInput('garagePredictedMax', 'Communication', 'garageRefers')}
          </div>
        </div>
      </div>);
  }

  renderParkingRow = () => {
    const states = ['parkingActual', 'parkingPredictedMin', 'parkingPredictedMax'];
    return (
      <div style={{ marginTop: '20px' }}>
        {this.renderTitles('Nie dotyczy', 'Istniejąca liczba miejsc do parkowania', 'Projektowana liczba miejsc do parkowania - minimalna', 'Projektowana liczba miejsc do parkowania - maksymalna')}
        <div className='col-sm-12'>
          <div className='col-sm-3' style={{ textAlign: 'center' }}>
            {this.renderSpecifiedCheckbox('parkingRefers', 'Communication', states, [v.NotNull, v.isNumber])}
          </div>
          <div className='col-sm-3'>
            {this.renderInput('parkingActual', 'Communication', 'parkingRefers')}
          </div>
          <div className='col-sm-3'>
            {this.renderInput('parkingPredictedMin', 'Communication', 'parkingRefers')}
          </div>
          <div className='col-sm-3'>
          {this.renderInput('parkingPredictedMax', 'Communication', 'parkingRefers')}
          </div>
        </div>
      </div>);
  }

  renderOtherParkingRow = () => {
    const states = ['otherParkingActual', 'otherParkingPredictedMin', 'otherParkingPredictedMax'];
    return (
      <div style={{ marginTop: '20px' }}>
        {this.renderTitles('Nie dotyczy', 'Istniejąca liczba miejsc do parkowania', 'Projektowana liczba miejsc do parkowania - minimalna', 'Projektowana liczba miejsc do parkowania - maksymalna')}
        <div className='col-sm-12'>
          <div className='col-sm-3' style={{ textAlign: 'center' }}>
            {this.renderSpecifiedCheckbox('otherParkingRefers', 'Communication', states, [v.NotNull, v.isNumber])}
          </div>
          <div className='col-sm-3'>
            {this.renderInput('otherParkingActual', 'Communication', 'otherParkingRefers')}
          </div>
          <div className='col-sm-3'>
            {this.renderInput('otherParkingPredictedMin', 'Communication', 'otherParkingRefers')}
          </div>
          <div className='col-sm-3'>
          {this.renderInput('otherParkingPredictedMax', 'Communication', 'otherParkingRefers')}
          </div>
        </div>
      </div>);
  }

  renderTitleRow = (state, group, label, states2Validate, states2Disable) => {
    return (
      <div className='col-sm-12' style={{ marginTop: '20px', textAlign: 'center' }} id={`${group}_${state}_TitleRow`}>
        <div className='col-sm-6' style={{ textAlign: 'left' }}>
          {this.renderLabeledCheckbox(state, group, label, states2Validate, [v.NotNull], states2Disable)}
        </div>
        <div className='col-sm-3'>
          <p><b>Istniejące</b></p>
        </div>
        <div className='col-sm-3'>
          <p><b>Projektowane</b></p>
        </div>
        <hr />
      </div>
    );
  }

  renderLabeledCheckboxesRow = (label, buttonsList, group, dependedOn) => {
    return (
      <div className="col-sm-12" style={{ textAlign: 'center' }}>
        <div className="col-sm-6" style={{ textAlign: 'left' }}>
          <p><b>{label}</b></p>
        </div>
        {buttonsList.map((item, index) => (
          <div className="col-sm-3" key={`LabeledCheckboxesRow_label_${index}`}>
            <input
              id={`${item.state}_${index}`}
              name={item.state}
              type="checkbox"
              style={checkBoxStyle}
              value={this.state[group][item.state]}
              checked={this.state[group][item.state]}
              disabled={!this.state[group][dependedOn]}
              onChange={e => this.onChangeCheckboxesRow(item.state, group, buttonsList)}
            />
          </div>
          ))
        }
      </div>
    )
  }

  renderLabeledCheckbox = (state, group, label, states2Validate, validatorsList, states2Disable) => {
    return (
      <div>
        <input
          id={state}
          name={state}
          type="checkbox"
          style={checkBoxStyle}
          value={this.state[group][state]}
          checked={this.state[group][state]}
          onChange={e => this.onChangeLabeledCheckbox(state, group, states2Validate, validatorsList, states2Disable)}
        />
        <label
        htmlFor={state}>
          <p>&nbsp;&nbsp;{label}</p>
        </label>
      </div>
    )
  }

  renderCheckboxesRow = (buttonsList, group) => {
    return (
      <div style={{ marginBottom: '20px' }}>
        <div className="col-sm-12">
          {buttonsList.map((item, index) => (
          <div className="col-sm-3" style={{ textAlign: 'center' }} key={`CheckboxesRow_label_${index}`}>
            <p>
              <b>{item.label}</b>
            </p>
          </div>
            ))
          }
        </div>
        <div className="col-sm-12">
          {buttonsList.map((item, index) => (
            <div className="col-sm-3" style={{ textAlign: 'center' }} key={`CheckboxesRow_input_${index}`}>
              <input
                id={`${item.state}_${index}`}
                name={item.state}
                type="checkbox"
                style={checkBoxStyle}
                value={this.state[group][item.state]}
                checked={this.state[group][item.state]}
                onChange={e => this.onChangeCheckboxesRow(item.state, group, buttonsList)}
              />
            </div>
            ))
          }
        </div>
      </div>
    )
  }

  renderSpecifiedCheckbox = (state, group, states2Validate, validatorsList) => {
    return (
      <input
        id={state}
        name={state}
        type="checkbox"
        style={checkBoxStyle}
        value={this.state[group][state]}
        checked={this.state[group][state]}
        onChange={e => this.onChangeSpecifiedCheckbox(state, group, states2Validate, validatorsList)}
      />
    )
  }

  renderInput = (state, group, dependedOn) => {
    return (
      <div>
        <input
          className="form-control"
          value={this.state[group][state]}
          name={state}
          onChange={e => this.onChange(e, group)}
          disabled={this.state[group][dependedOn]}
          style={{
            width: '100%',
            borderColor:
              Object.keys(this.state.errors).indexOf(state) > -1 &&
                this.state.errors[state] !== null &&
                this.state.errors[state].length > 0
                ? 'red'
                : '#ccc',
          }}
        />
        {Object.keys(this.state.errors).indexOf(state) > -1 &&
          this.state.errors[state] !== null &&
          this.state.errors[state].length > 0
          ? this.state.errors[state].map((val, index) => (
            <span key={index} style={errorSpanStyle}>
              {val}
            </span>
          ))
          : null}
      </div>
    )
  }

  renderMapDescription = (id) => {
    const isMobile = this.state.isMounted && isMobileView(window);
    const isTablet = this.state.isMounted && isTabletView(window);
    return (
      <div className="help-desc" id={id}>
        <br /><br /><br />
        { renderHelpDesc(isMobile, isTablet) }
    </div>
    );
  }

  renderAtticTypeRow = (group = 'AttachmentB') => {
    return (
      <div>
        {this.renderTitles('użytkowe', 'nieużytkowe', 'nie dotyczy', '')}
        <div className="col-sm-12" style={{ textAlign: 'center', marginBottom: '20px' }}>
          {atticTypeOptions.map((item, index) => (
            item.type === 'checkbox' ?
              this.renderCheckboxInRow(group, item, index, atticTypeOptions4Checkbox): null
            ))
          }
        </div>
      </div>
    );
  }

  renderRoofTypeRow = () => {
    return (
      <div>
        {this.renderRadioButtons(roofTypeOptions, 'AttachmentB', 'roofType')}
        <br />
      </div>
    );
  }

  renderRoofSlopeRow = (group = 'AttachmentB') => {
    return (
      <div>
        {this.renderTitles('Symetryczny', 'Bez zmian', 'Inny', '')}
        <div className="col-sm-12" style={{ textAlign: 'center', marginBottom: '20px' }}>
          {roofSlopeOptions.map((item, index) => (
            item.type === 'checkbox' ?
              this.renderCheckboxInRow(group, item, index, roofSlopeOptions4Checkbox): null
            ))
          }
        </div>
      </div>
    );
  }

  renderRidgeTypeRow = (group = 'AttachmentB') => {
    return (
      <div>
        {this.renderTitles('Prostopadły', 'Równoległy', 'Bez zmian', 'Inny')}
        <div className="col-sm-12" style={{ textAlign: 'center', marginBottom: '20px' }}>
          {ridgeTypeOptions.map((item, index) => (
            item.type === 'checkbox' ?
              this.renderCheckboxInRow(group, item, index, ridgeTypeOptions4Checkbox) : null
            ))
          }
        </div>
      </div>
    );
  }

  renderDistanceToBorderRow = (group = 'AttachmentB') => {
    return (
      <div>
        {this.renderTitles('4 m i więcej', 'mniej niż 4 m', '', '')}
        <div className="col-sm-12" style={{ textAlign: 'center', marginBottom: '20px' }}>
          {distanceToBorderOptions.map((item, index) => (
            item.type === 'checkbox' ?
              this.renderCheckboxInRow(group, item, index, distanceToBorderOptions4Checkbox) : null
            ))
          }
        </div>
      </div>
    );
  }

  renderDistanceWallsToBorderRow = (group = 'AttachmentB') => {
    return (
      <div>
        {this.renderTitles('3 m i więcej', 'mniej niż 3 m', '', '')}
        <div className="col-sm-12" style={{ textAlign: 'center', marginBottom: '20px' }}>
          {distanceWallsToBorderOptions.map((item, index) => (
            item.type === 'checkbox' ?
            this.renderCheckboxInRow(group, item, index, distanceWallsToBorderOptions4Checkbox) : null
            ))
          }
        </div>
      </div>
    );
  }

  renderObjectTypeRow = (group = 'AttachmentC') => {
    return (
      <div>
        {this.renderTitles('budowla', 'urządzenie wodne', 'inne', 'inne - opis')}
        <div className="col-sm-12" style={{ textAlign: 'center' }}>
          {objectTypeOptions.map((item, index) => (
            item.type === 'checkbox' ?
              this.renderCheckboxInRow(group, item, index, objectTypeOptions4Checkbox) :
              <div className="col-sm-3" key={`objectTypeOther_${index}`}>
                <textarea
                  name={item.state}
                  style={{
                    width: '100%',
                    borderColor:
                      Object.keys(this.state.errors).indexOf(item.state) > -1 &&
                        this.state.errors[item.state] !== null &&
                        this.state.errors[item.state].length > 0
                        ? 'red'
                        : '#ccc',
                  }}
                  className="form-control"
                  rows={1}
                  value={this.state[group][item.state] ? this.state[group][item.state] : ''}
                  onChange={e => this.onChange(e, group)}
                  disabled={!this.state[group]['objectType3']}
                />
                {/* RENDER ERROS IN SPAN */}
                {Object.keys(this.state.errors).indexOf(item.state) > -1 &&
                  this.state.errors[item.state] !== null &&
                  this.state.errors[item.state].length > 0
                  ? this.state.errors[item.state].map((val, index) => (
                    <span key={index} style={errorSpanStyle}>
                      {val}
                    </span>
                  ))
                  : null}
              </div>
            ))
          }
        </div>
      </div>
    );
  }

  renderInvestmentClassificationRow = (group = 'AttachmentE') => {
    return (
      <div>
        {this.renderAttachmentETitles('Zakład o zwiększonym ryzyku wystąpienia poważnej awarii przemysłowej', 'Zakład o dużym ryzyku wystąpienia poważnej awarii przemysłowej', '', '')}
        <div className="col-sm-12" style={{ textAlign: 'center' }}>
          {investmentClassificationOptions.map((item, index) => (
            item.type === 'checkbox' ?
              this.renderCheckboxInRow(group, item, index, investmentClassificationOptions4Checkbox, 6) :
              <div className="col-sm-3" key={`objectTypeOther_${index}`}>
                <textarea
                  name={item.state}
                  style={{
                    width: '100%',
                    borderColor:
                      Object.keys(this.state.errors).indexOf(item.state) > -1 &&
                        this.state.errors[item.state] !== null &&
                        this.state.errors[item.state].length > 0
                        ? 'red'
                        : '#ccc',
                  }}
                  className="form-control"
                  rows={1}
                  value={this.state[group][item.state] ? this.state[group][item.state] : ''}
                  onChange={e => this.onChange(e, group)}
                />
                {/* RENDER ERROS IN SPAN */}
                {Object.keys(this.state.errors).indexOf(item.state) > -1 &&
                  this.state.errors[item.state] !== null &&
                  this.state.errors[item.state].length > 0
                  ? this.state.errors[item.state].map((val, index) => (
                    <span key={index} style={errorSpanStyle}>
                      {val}
                    </span>
                  ))
                  : null}
              </div>
            ))
          }
        </div>
      </div>
    );
  }

  renderAreaRow = (group = 'AttachmentE') => {
    return (
      <div>
        {this.renderAttachmentETitles('TAK', 'NIE', '', '')}
        <div className="col-sm-12" style={{ textAlign: 'center' }}>
          {areaOptions.map((item, index) => (
            item.type === 'checkbox' ?
              this.renderCheckboxInRow(group, item, index, areaOptions4Checkbox, 6) :
              <div className="col-sm-3" key={`objectTypeOther_${index}`}>
                <textarea
                  name={item.state}
                  style={{
                    width: '100%',
                    borderColor:
                      Object.keys(this.state.errors).indexOf(item.state) > -1 &&
                        this.state.errors[item.state] !== null &&
                        this.state.errors[item.state].length > 0
                        ? 'red'
                        : '#ccc',
                  }}
                  className="form-control"
                  rows={1}
                  value={this.state[group][item.state] ? this.state[group][item.state] : ''}
                  onChange={e => this.onChange(e, group)}
                />
                {/* RENDER ERROS IN SPAN */}
                {Object.keys(this.state.errors).indexOf(item.state) > -1 &&
                  this.state.errors[item.state] !== null &&
                  this.state.errors[item.state].length > 0
                  ? this.state.errors[item.state].map((val, index) => (
                    <span key={index} style={errorSpanStyle}>
                      {val}
                    </span>
                  ))
                  : null}
              </div>
            ))
          }
        </div>
      </div>
    );
  }

  renderObjectWorksRow = () => {
    return (
      <div>
        {this.renderRadioButtons(objectWorksOptions, 'AttachmentC', 'objectWork')}
        <br />
        {this.state.AttachmentC.objectWork === 'inne' ? 
          this.getTextAreaWithError('Inne', 'AttachmentC', 'objectWorkOther')
        : null}
      </div>
    );
  }

  renderBuildingWorksRow = () => {
    return (
      <div>
        {this.renderRadioButtons(buildingWorksOptions, 'AttachmentB', 'buildWork')}
        <br />
        {this.state.AttachmentB.buildWork === 'inne' ? 
          this.getTextAreaWithError('Inne', 'AttachmentB', 'buildWorkOther')
        : null}
      </div>
    );
  }

  renderCheckboxInRow = (group, item, index, buttonsList=[], colSize=3) => {
    return (
      <div className={`col-sm-${colSize}`} key={`${item.state}_${index}`}>
        <input
          id={`${item.state}_${index}`}
          name={item.state}
          type="checkbox"
          style={checkBoxStyle}
          value={this.state[group][item.state]}
          checked={this.state[group][item.state]}
          onChange={e => this.onChangeCheckboxesRow(item.state, group, buttonsList)}
        />
      </div>
    );
  }

  renderAttachmentCheckbox = (label, group, state, states2Validate) => {
    return(
      <div>
        <input
          id={`checkbox${state}_${group}`}
          name={`checkbox${state}`}
          type="checkbox"
          value={this.state[group][state]}
          checked={this.state[group][state]}
          onChange={e => this.onChangeAttachmentCheckbox(state, group, states2Validate)}
        />
        <label
          htmlFor={`checkbox${state}_${group}`}>
            <p>&nbsp;&nbsp;{label}</p>
        </label>
      </div>
    )
  }
  renderAttachmentA = () => {
    return(
      <div>
        {this.renderTitleRow('waterAccessRefers', 'AttachmentA', 'Dostęp do wody', ['waterNeeds'], water2Disable)}
        {this.renderLabeledCheckboxesRow('przyłącze wodociągowe', waterworksOptions, 'AttachmentA', 'waterAccessRefers')}
        {this.renderLabeledCheckboxesRow('studnia do poboru wody pitnej', wellOptions, 'AttachmentA', 'waterAccessRefers')}
        {this.renderLabeledCheckboxesRow('inne', otherWaterOptions, 'AttachmentA', 'waterAccessRefers')}
        {this.getTextAreaWithError('Zapotrzebowanie oraz dodatkowe informacje', 'AttachmentA', 'waterNeeds')}

        {this.renderTitleRow('sewageRefers', 'AttachmentA', 'Odprowadzenie ścieków', ['sewageNeeds'], sewage2Disable)}
        {this.renderLabeledCheckboxesRow('przyłącze kanalizacyjne', networkConnectionOptions, 'AttachmentA', 'sewageRefers')}
        {this.renderLabeledCheckboxesRow('bezodpływowy zbiornik na nieczystości ciekłe', drainlessTankOptions, 'AttachmentA', 'sewageRefers')}
        {this.renderLabeledCheckboxesRow('indywidualna oczyszczalnia ścieków', treatmentOptions, 'AttachmentA', 'sewageRefers')}
        {this.renderLabeledCheckboxesRow('inne', otherSewageOptions, 'AttachmentA', 'sewageRefers')}
        {this.getTextAreaWithError('Zapotrzebowanie oraz dodatkowe informacje', 'AttachmentA', 'sewageNeeds')}

        {this.renderTitleRow('otherSewageRefers', 'AttachmentA', 'Odprowadzanie i oczyszczanie ścieków innych niż w pkt A.1.2', ['otherSewageNeeds'], otherSewage2Disable)}
        {this.renderLabeledCheckboxesRow('przyłącze do kanalizacji po wcześniejszym podczyszczeniu', sewageConnectionOptions, 'AttachmentA', 'otherSewageRefers')}
        {this.renderLabeledCheckboxesRow('bezodpływowy zbiornik na ścieki', drainlessSewegeTankOptions, 'AttachmentA', 'otherSewageRefers')}
        {this.renderLabeledCheckboxesRow('indywidualna oczyszczalnia ścieków', individualSewageTankOptions, 'AttachmentA', 'otherSewageRefers')}
        {this.renderLabeledCheckboxesRow('bezodpływowy zbiornik na ścieki odzwierzęce', animalWastewaterOptions, 'AttachmentA', 'otherSewageRefers')}
        {this.renderLabeledCheckboxesRow('płyta obornikowa', manurePlateOptions, 'AttachmentA', 'otherSewageRefers')}
        {this.renderLabeledCheckboxesRow('inne', otherOtherSewageOptions, 'AttachmentA', 'otherSewageRefers')}
        {this.getTextAreaWithError('Zapotrzebowanie oraz dodatkowe informacje', 'AttachmentA', 'otherSewageNeeds')}

        {this.renderTitleRow('snowmeltDrainageRefers', 'AttachmentA', 'Odprowadzenie wód opadowych i roztopowych', ['snowmeltDrainageNeeds'], snowmelt2Disable)}
        {this.renderLabeledCheckboxesRow('przyłącze do kanalizacji deszczowej', rainwaterDrainageOptions, 'AttachmentA', 'snowmeltDrainageRefers')}
        {this.renderLabeledCheckboxesRow('na własny nieutwardzony teren inwestycji', unpavedInvestmentAreaOptions, 'AttachmentA', 'snowmeltDrainageRefers')}
        {this.renderLabeledCheckboxesRow('na własny teren inwestycji, do dołów chłonnych lub zbiorników retencyjnych', retentionReservoirsOptions, 'AttachmentA', 'snowmeltDrainageRefers')}
        {this.renderLabeledCheckboxesRow('inne', otherSnowmeltDrainageOptions, 'AttachmentA', 'snowmeltDrainageRefers')}
        {this.getTextAreaWithError('Zapotrzebowanie oraz dodatkowe informacje', 'AttachmentA', 'snowmeltDrainageNeeds')}

        {this.renderTitleRow('electricityRefers', 'AttachmentA', 'Dostęp do energii elektrycznej', ['electricityNeeds'], electricity2Disable)}
        {this.renderLabeledCheckboxesRow('przyłącze do sieci', electricityNetworkConnectionOptions, 'AttachmentA', 'electricityRefers')}
        {this.renderLabeledCheckboxesRow('instalacja pozyskująca energię elektryczną ze źródeł odnawialnych', renewableSourcesOptions, 'AttachmentA', 'electricityRefers')}
        {this.renderLabeledCheckboxesRow('inne', otherElectricityOptions, 'AttachmentA', 'electricityRefers')}
        {this.getTextAreaWithError('Zapotrzebowanie oraz dodatkowe informacje', 'AttachmentA', 'electricityNeeds')}

        {this.renderTitleRow('gasRefers', 'AttachmentA', 'Dostęp do gazu', ['gasNeeds'], gas2Disable)}
        {this.renderLabeledCheckboxesRow('przyłącze do sieci', gasConnectionOptions, 'AttachmentA','gasRefers')}
        {this.renderLabeledCheckboxesRow('naziemny zbiornik na gaz płynny', abovegroundLPGTankOptions, 'AttachmentA','gasRefers')}
        {this.renderLabeledCheckboxesRow('podziemny zbiornik na gaz płynny', undergroundLPGTankOptions, 'AttachmentA','gasRefers')}
        {this.renderLabeledCheckboxesRow('inne', otherGasOptions, 'AttachmentA','gasRefers')}
        {this.getTextAreaWithError('Zapotrzebowanie oraz dodatkowe informacje', 'AttachmentA', 'gasNeeds')}

        {this.renderTitleRow('heatRefers', 'AttachmentA', 'Źródło ciepła', ['heatNeeds'], heat2Disable)}
        {this.renderLabeledCheckboxesRow('przyłącze do sieci ciepłowniczej', heatConnectionOptions, 'AttachmentA', 'heatRefers')}
        {this.renderLabeledCheckboxesRow('indywidualne źródło ciepła', individualHeatSourceOptions, 'AttachmentA', 'heatRefers')}
        {this.renderLabeledCheckboxesRow('instalacja pozyskująca energię cieplną ze źródeł odnawialnych', renewableHeatSourceOptions, 'AttachmentA', 'heatRefers')}
        {this.renderLabeledCheckboxesRow('inne', otherHeatSourceOptions, 'AttachmentA', 'heatRefers')}
        {this.getTextAreaWithError('Zapotrzebowanie oraz dodatkowe informacje', 'AttachmentA', 'heatNeeds')}

        {this.renderTitleRow('wasteManagementRefers', 'AttachmentA', 'Gospodarowanie odpadami', ['wasteManagementNeeds'], waste2Disable)}
        {this.renderLabeledCheckboxesRow('zgodnie z regulaminem utrzymania czystości i porządku na terenie gminy', wasteRulesOptions, 'AttachmentA', 'wasteManagementRefers')}
        {this.renderLabeledCheckboxesRow('inne', otherWasteOptions, 'AttachmentA', 'wasteManagementRefers')}
        {this.getTextAreaWithError('Zapotrzebowanie oraz dodatkowe informacje', 'AttachmentA', 'wasteManagementNeeds')}

        {this.renderTitleRow('connectionNetworksRefers', 'AttachmentA', 'Zaopatrzenie w środki łączności', ['connectionNetworksNeeds'], connectionNetworks2Disable)}
        {this.renderLabeledCheckboxesRow('przyłącze do sieci', connectionNetworksOptions, 'AttachmentA', 'connectionNetworksRefers')}
        {this.getTextAreaWithError('Zapotrzebowanie oraz dodatkowe informacje', 'AttachmentA', 'connectionNetworksNeeds')}

        {this.getTextAreaWithError('Dodatkowe informacje z zakresu infrastruktury technicznej', 'AttachmentA', 'otherTechInfo')}
      </div>
    )
  }

  renderAttachmentB = () => {
    return(
      <div>
          {this.getTextAreaWithError('Nazwa budynku', 'AttachmentB', 'buildingName')}
          {this.getTextAreaWithError('Funkcja budynku (zgodnie z Polską Klasyfikacją Obiektów Budowlanych)', 'AttachmentB', 'buildingFunction')}
          <p><b>Liczba lokali mieszkalnych, w przypadku budynku mieszkalnego:</b></p>
          {this.getInputWithError('istniejąca', 'AttachmentB', 'flatCountActual')}
          {this.getInputWithError('projektowana', 'AttachmentB', 'flatCountProjected')}
          <br />
          <p><b>Rodzaj prac dotyczących budynku:</b></p>
          {this.renderBuildingWorksRow()}

          <br />
          <div>
            <p><b>Charakterystyczne parametry budynku:</b></p>
            <hr style={{marginTop: '-10px'}} />
          </div>
          {this.renderSpecifiedDataRow('Szerokość elewacji frontowej [m]', frontFacadeWidthStates2Validate, 'AttachmentB', frontFacadeWidthCheckbox, frontFacadeWidthInputs, '20px')}
          {this.renderSpecifiedDataRow('Suma powierzchni kondygnacji nadziemnych [m2]', overgroundStoreysAreaCountStates2Validate, 'AttachmentB', overgroundStoreysAreaCountCheckbox, overgroundStoreysAreaCountInputs, marginTop)}
          {this.renderSpecifiedDataRow('Liczba kondygnacji nadziemnych', overgroundStoreysStates2Validate, 'AttachmentB', overgroundStoreysCheckbox, overgroundStoreysInputs, marginTop)}
          {this.renderSpecifiedDataRow('Suma powierzchni kondygnacji podziemnych [m2]', undergroundStoreysAreaCountStates2Validate, 'AttachmentB', undergroundStoreysAreaCountCheckbox, undergroundStoreysAreaCountInputs, marginTop)}
          {this.renderSpecifiedDataRow('Liczba kondygnacji podziemnych', undergroundStoreysStates2Validate, 'AttachmentB', undergroundStoreysCheckbox, undergroundStoreysInputs, marginTop)}
          {this.renderSpecifiedDataRow('Wysokość [m]', mainRidgeHeightStates2Validate, 'AttachmentB', mainRidgeHeightCheckbox, mainRidgeHeightInputs, marginTop)}
          {this.renderSpecifiedDataRow('Kąt nachylenia dachu [stopnie]', roofSlopeStates2Validate, 'AttachmentB', roofSlopeCheckbox, roofSlopeInputs, marginTop)}
          <p style={{ marginLeft: marginLeft, marginBottom: marginBottom, marginTop: marginTop }}><b>Rodzaj poddasza, jeśli znajduje się w budynku</b></p>
          {this.renderAtticTypeRow()}
          <br />
          <br />
          <div>
            <p><b>Informacje dotyczące dachu:</b></p>
            <hr style={{marginTop: '-10px'}} />
          </div>
          <br />
          <p style={{ marginLeft: marginLeft }}><b>Rodzaj projektowanego dachu</b></p>
          <div style={{ marginLeft: marginLeft }}>
          {this.renderRoofTypeRow()}
          </div>
          <br />
          {this.getTextAreaWithError('Dodatkowe informcje', 'AttachmentB', 'roofTypeAdditional', marginLeft)}
          <p style={{ marginLeft: marginLeft }}><b>Projektowany układ głównych połaci dachu</b></p>
          {this.renderRoofSlopeRow()}
          <br />
          {this.getTextAreaWithError('Dodatkowe informcje', 'AttachmentB', 'roofSlopeAdditional', marginLeft)}
          <p style={{ marginLeft: marginLeft }}><b>Projektowany kierunek głównej kalenicy w stosunku do frontu działki</b></p>
          {this.renderRidgeTypeRow()}
          <br />
          {this.getTextAreaWithError('Dodatkowe informcje', 'AttachmentB', 'ridgeTypeAdditional', marginLeft)}
          {this.getTextAreaWithError('Projektowany rodzaj i kolor pokrycia dachowego w przypadku obiektów lub terenu objętych ochroną konserwatorską', 'AttachmentB', 'roofColorInfo', marginLeft)}
          <p style={{ marginTop: marginTop }}><b>Odległość budynku zwróconego ścianą z oknami lub drzwiami od granicy działki budowlanej</b></p>
          {this.renderDistanceToBorderRow()}
          <br />
          <p><b>Odległość budynku zwróconego ścianą bez okien i drzwi od granicy działki budowlanej</b></p>
          {this.renderDistanceWallsToBorderRow()}
          <br />
          {this.getTextAreaWithError('Inne parametry budynku niewymienione powyżej, w tym dotyczące uwarunkowań wynikających z funkcjonującej ochrony konserwatorskiej w przypadku obiektów lub terenu nimi objętych oraz dotyczące uwarunkowań wynikających z położenia na obszarach szczególnego zagrożenia powodzią', 'AttachmentB', 'otherParams')}
          {this.getInputWithError('Liczba budynków o takich samych parametrach, w przypadku gdy wniosek obejmuje większą liczbę takich budynków', 'AttachmentB', 'sameBuildingsCount')}
      </div>
    )
  }

  renderAttachmentC = () => {
    return(
      <div>
          {this.getTextAreaWithError('Nazwa obiektu budowlanego niebędącego budynkiem', 'AttachmentC', 'nonBuildingName')}
          <p><b>Rodzaj obiektu niebędącego budynkiem</b></p>
          {this.renderObjectTypeRow()}
          <p><b>Rodzaj prac dotyczących obiektu</b></p>
          {this.renderObjectWorksRow()}
          <div>
            <p><b>Charakterystyczne parametry obiektu:</b></p>
            <hr style={{marginTop: '-10px'}} />
          </div>
          <br />
          {this.renderSpecifiedDataRow('Powierzchnia [m2]:', objectAreaStates2Validate, 'AttachmentC', objectAreaCheckbox, objectAreaInputs, '20px')}
          {this.renderSpecifiedDataRow('Kubatura, objętość, pojemność [m3]:', objectCapacityStates2Validate, 'AttachmentC', objectCapacityCheckbox, objectCapacityInputs, marginTop)}
          {this.renderSpecifiedDataRow('Długość [m]:', objectLengthStates2Validate, 'AttachmentC', objectLengthCheckbox, objectLengthInputs, marginTop)}
          {this.renderSpecifiedDataRow('Szerokość [m]:', objectWidthStates2Validate, 'AttachmentC', objectWidthCheckbox, objectWidthInputs, marginTop)}
          {this.renderSpecifiedDataRow('Wysokość [m]:', objectHeigthStates2Validate, 'AttachmentC', objectHeigthCheckbox, objectHeigthInputs, marginTop)}
          <br />
          <br />
          <br />
          {this.getTextAreaWithError('Inne parametry obiektu budowlanego, niezdefiniowane powyżej', 'AttachmentC', 'objectOtherParams', marginLeft)}
          {this.getTextAreaWithError('Liczba obiektów budowlanych niebędących budynkami o takich samych parametrach, w przypadku gdy wniosek obejmuje większą liczbę takich obiektów', 'AttachmentC', 'sameObjectsCount')}
      </div>
    )
  }

  renderAttachmentD = () => {
    return(
      <div>
        {this.getTextAreaWithError('Docelowa rzędna składowiska odpadów', 'AttachmentD', 'landfillOrdinate')}
        {this.getTextAreaWithError('Roczna ilość składowanych odpadów oraz rodzaje składowanych odpadów', 'AttachmentD', 'annualLandfilledWaste')}
        {this.getTextAreaWithError('Całkowita ilość składowanych odpadów oraz rodzaje składowanych odpadów', 'AttachmentD', 'wasteDepositedAmount')}
        {this.getTextAreaWithError('Sposób gromadzenia, oczyszczania i odprowadzania ścieków', 'AttachmentD', 'wastewaterMethod')}
        {this.getTextAreaWithError('Sposób gromadzenia, oczyszczania i wykorzystywania lub unieszkodliwiania gazu składowiskowego', 'AttachmentD', 'landfillGasMethod')}
        {this.getTextAreaWithError('Inne parametry składowiska odpadów, niezdefiniowane powyżej', 'AttachmentD', 'landfillOther')}
      </div>
    )
  }

  renderAttachmentE = () => {
    return(
      <div>
        <p><b>Kwalifikacja inwestycji</b></p>
        {this.renderInvestmentClassificationRow()}
        <p style={{ marginTop: marginTop }}></p>
        {this.getTextAreaWithError('Przewidywane rodzaje i ilości substancji niebezpiecznych w zakładzie, decydujących o zaliczeniu do zakładu o zwiększonym lub dużym ryzyku wystąpienia poważnej awarii przemysłowej', 'AttachmentE', 'hazardousSubstances')}
        <p><b>Przewidywany zasięg potencjalnych skutków poważnych awarii przemysłowych wykracza poza teren inwestycji</b></p>
        {this.renderAreaRow()}
        <p style={{ marginTop: marginTop }}></p>
        {this.getTextAreaWithError('Informacje i dane na temat obszaru, skali i prawdopodobieństwa wystąpienia potencjalnych skutków poważnych awarii przemysłowych wykraczających poza teren inwestycji, z uwzględnieniem wartości parametrów granicznych oddziaływania potencjalnych skutków tych awarii w zakresie palności, wybuchowości i toksyczności substancji niebezpiecznych', 'AttachmentE', 'areaInfo')}
        {this.getTextAreaWithError('Dodatkowe informacje', 'AttachmentE', 'additionalInfo')}
      </div>
    )
  }

  render() {
    return (
      <div style={{ paddingTop: '20px' }}>
        {this.props.district === "205011" ?
          <h4 style={{ textAlign: 'justify', color: 'red', marginLeft: '15px', marginRight: '15px' }}>
            Uwaga! Ze względu na pełne pokrycie gminy miejscowymi planami
            zagospodarowania przestrzennego informujemy, że Urząd nie rozpatruje
            wniosków ws. wydania decyzji o warunkach zabudowy oraz wniosków ws.
            ustalenia lokalizacji inwestycji celu publicznego. Prosimy o składanie
            wniosków ws. wydania wypisu i wyrysu z miejscowego planu zagospodarowania
            przestrzennego.
        </h4> : null
        }

        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />

        <DecisionContainer
          title={'Dodatkowe dane dot. wnioskodawcy'}
          data={this.state.DecisionData}
          errors={this.state.errors}
          formDict={UserFormDict}
          onChange={e => this.onChange(e, 'DecisionData')}
        />

        <CheckableDecisionContainer
          title={'1. Dane pełnomocnika'}
          checkboxText={'Dodaj pełnomocnika'}
          data={this.state.Agent}
          errors={this.state.errors}
          formDict={AgentDict}
          onChange={e => this.onChange(e, 'Agent')}
          isChecked={this.state.Agent.AddAgent}
          onChangeCheckbox={this.onCheckAgent}
          extraCheckbox={{
            label: 'Dodaj pełnomocnika do doręczeń',
            state: 'DeliveryAgent',
            group: 'Agent',
            isChecked: this.state.Agent.DeliveryAgent,
            onChange: this.onChangeCheckbox,       
          }}
        />

        <DecisionContainer
          title={'2. Teren objęty wnioskiem'}
          data={this.state.DecisionData}
          errors={this.state.errors}
          formDict={AddressFormDict}
          onChange={e => this.onChange(e, 'DecisionData')}
        >
          <br />
          {this.renderMapDescription('CustomizedMap_1')}
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
            mpzpValidator={this.mpzpValidator}
            checkNonMPZP={!districtsToSkipMPZP.includes(this.props.prefix)}
            // districtsToSkipMPZP- nie sprawdzamy MPZP, (np. wszystkie działki są objęte MPZP)
          />
          <p>
            <br />
            <b>
            Sposób wyznaczenia terenu inwestycji (wskazanego w terenie objętym wnioskiem):
            </b>
          </p>
          {this.renderRadioButtons(isPartOptions, 'InvestCharacteristics', 'isPart')}
          <p>
              <br />
              <b>*</b> Należy uzupełnić w przypadku, gdy dla terenu objętego wnioskiem
                został nadany numer porządkowy (adres)
          </p>
          <p>
              <b>**</b> W przypadku określenia granic terenu objętego wnioskiem jako część działki ewidencyjnej lub działek ewidencyjnych
              wymagane jest określenie granic terenu w formie graficznej.
          </p>
        </DecisionContainer>

        <DecisionContainer
          title={'3. Charakterystyka inwestycji'}
          data={this.state.InvestCharacteristics}
          errors={this.state.errors}
          formDict={InvestCharacteristicsDict}
          onChange={e => this.onChange(e, 'InvestCharacteristics')}
        >
          <p>
            <br />
            <b>*</b> Zgodnie ze standardami określonymi w przepisach wykonawczych wydanych na podstawie art. 16 ust. 2 ustawy z dnia
                27 marca 2003 r. o planowaniu i zagospodarowaniu przestrzennym.
          </p>
        </DecisionContainer>
        <DecisionContainer
          title={'4. Parametry dotyczące terenu inwestycji'}
          data={this.state.InvestCharacteristics}
          errors={this.state.errors}
          formDict={LandDict}
          onChange={e => this.onChange(e, 'InvestCharacteristics')}
        >
          <br />
          <div style={{ marginTop: '20px' }}>
            {this.renderSpecifiedDataRow('Powierzchnia zabudowy [m2]:', buildingsAreaStates2Validate, 'InvestCharacteristics', buildingsAreaCheckbox, buildingsAreaInputs, marginTop)}
            <br />
            <br />
            <br />
            {this.renderSpecifiedDataRow('Powierzchnia biologicznie czynna [m2]:', biologicalSurfaceStates2Validate, 'InvestCharacteristics', biologicalSurfaceCheckbox, biologicalSurfaceInputs, marginTop)}
            <br />
            <br />
            <br />
            {this.renderSpecifiedDataRow('Powierzchnia podlegająca przekształceniu [m2]:', transformationSurfaceStates2Validate, 'InvestCharacteristics', transformationSurfaceCheckbox, transformationSurfaceInputs, marginTop)}
          </div>
          <p style={{ marginTop: '20px' }}>
            <b>*</b> Nieobowiązkowe
          </p>
        </DecisionContainer>

        <GrayPanel title={'5. Obsługa komunikacyjna'}>
          <p style={{ marginTop: '20px' }}><b>Dostęp do drogi publicznej:</b></p>
          {this.renderCheckboxesRow(publicRoadOptions, 'Communication')}
          <br />
          {this.renderMapDescription('CustomizedMap_2')}
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setRoadParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedRoadParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
          <br />
          <br />
          {this.getTextAreaWithError('Dodatkowe informacje dotyczące dostępu do drogi publicznej:**', 'Communication', 'publicRoadAdditional')}

          <p style={{ marginTop: '20px' }}><b>Wnioskowana liczba miejsc do parkowania:</b></p>
          <br />
          <p><b>Garaż:</b></p>
          {this.renderGarageRow()}
          <br />
          <p style={{ marginTop: marginTop }}><b>Parking:</b></p>
          {this.renderParkingRow()}
          <br />
          <p style={{ marginTop: marginTop }}><b>Inne:</b></p>
          {this.renderOtherParkingRow()}
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          {this.getTextAreaWithError('Dodatkowe informacje dotyczące miejsc do parkowania:**', 'Communication', 'parkingAdditional')}
          <p style={{ marginTop: '20px' }}>
            <b>*</b> W przypadku pośredniego dostępu do drogi publicznej należy wskazać wszystkie działki ewidencyjne umożliwiające dostęp wraz z działką ewidencyjną obejmującą drogę publiczną.
            <br />
            <b>**</b> Nieobowiązkowe
          </p>
        </GrayPanel>

        <GrayPanel title={'6. Załącznik A - Dane dotyczące infrastruktury technicznej'}>
          {this.renderAttachmentCheckbox('Dodaj dane o załączniku', 'AttachmentA', 'checked', attachmentAFields2Validate)}

          {this.state.AttachmentA.checked ? this.renderAttachmentA() : null}

        </GrayPanel>

        <GrayPanel title={'7. Załącznik B - Dane dotyczące budyku'}>
          {this.renderAttachmentCheckbox('Dodaj dane o załączniku', 'AttachmentB', 'checked', [])}

          {this.state.AttachmentB.checked ? this.renderAttachmentB() : null}
        </GrayPanel>

        <GrayPanel title={'8. Załącznik C - Dane dotyczące obiektu budowlanego niebędącego budynkiem'}>
          {this.renderAttachmentCheckbox('Dodaj dane o załączniku', 'AttachmentC', 'checked', [])}

          {this.state.AttachmentC.checked ? this.renderAttachmentC() : null}
        </GrayPanel>

        <GrayPanel title={'9. Załącznik D - Dane dotyczące składowiska odpadów'}>
          {this.renderAttachmentCheckbox('Dodaj dane o załączniku', 'AttachmentD', 'checked', [])}

          {this.state.AttachmentD.checked ? this.renderAttachmentD() : null}
        </GrayPanel>

        <GrayPanel title={'10. Załącznik E - Dane dotyczące zakładu o zwiększonym lub dużym ryzyku wystąpienia poważnej awarii przemysłowej'}>
          {this.renderAttachmentCheckbox('Dodaj dane o załączniku', 'AttachmentE', 'checked', [])}

          {this.state.AttachmentE.checked ? this.renderAttachmentE() : null}
        </GrayPanel>

        <GrayPanel title={"Informacja dla wnioskodawcy"}>
          <div className="row">
            <div className="col-sm-12">
              <p>Do wniosku o wydanie decyzji należy załączyć, w uzgodnieniu z organem właściwym do wydania decyzji:</p>
              <ul>
                <li>Pełnomocnictwo do reprezentowania wnioskodawcy (opłacone zgodnie z ustawą z dnia 16 listopada 2006 r. o opłacie skarbowej (Dz. U. z 2023 r. poz. 2111)) – jeżeli wnioskodawca działa przez pełnomocnika.</li>
                <li>Potwierdzenie uiszczenia opłaty skarbowej – jeżeli obowiązek uiszczenia takiej opłaty wynika z ustawy z dnia 16 listopada 2006 r. o opłacie skarbowej.</li>
                <li>Mapa zasadnicza lub, w przypadku jej braku, mapa ewidencyjna</li>
                <li>Określenie granic terenu objętego wnioskiem, pokazanych na kopii mapy będącej załącznikiem, jeśli teren inwestycji stanowi część działki ewidencyjnej lub działek ewidencyjnych, wraz z podaniem wymiarów</li>
                <li>Określenie planowanego sposobu zagospodarowania terenu wraz z oznaczeniem frontu terenu oraz charakterystyki zabudowy i zagospodarowania terenu, w tym przeznaczenia i gabarytów projektowanych obiektów budowlanych oraz powierzchni terenu podlegającej przekształceniu, przedstawione w formie graficznej</li>
                <li>Kopia decyzji o środowiskowych uwarunkowaniach, o której mowa w art. 71 ust. 1 ustawy z dnia 3 października 2008 r. o udostępnianiu informacji o środowisku i jego ochronie, udziale społeczeństwa w ochronie środowiska oraz o ocenach oddziaływania na środowisko (Dz. U. z 2023 r. poz. 1094, z późn. zm.)</li>
                <li>Dokumenty potwierdzające zapewnienie dostępu inwestycji do infrastruktury technicznej, w tym w zakresie dostaw energii i w zakresie dostaw wody oraz odbioru ścieków bytowych – jeżeli istniejące uzbrojenie terenu nie jest wystarczające dla zamierzenia inwestycyjnego</li>
                <li>Obszar wystąpienia potencjalnych skutków poważnych awarii przemysłowych, przedstawiony w czytelnej technice graficznej – jeżeli wychodzą one poza teren inwestycji lub odrębne opracowanie analityczno-ocenne dotyczące możliwości oraz warunków realizacji inwestycji – zakładu o zwiększonym lub dużym ryzyku wystąpienia poważnej awarii przemysłowej</li>
                <li>Dokumenty wynikające z ustawy z dnia 20 lipca 2017 r. – Prawo wodne (Dz. U. z 2023 r. poz. 1478, z późn. zm.) – jeżeli inwestycja znajduje się na obszarze szczególnego zagrożenia powodzią.</li>
                <li>Inne (w tym np. licencja mapy, dokumenty, które pozwolą na ocenę spełnienia warunku dostępu do drogi publicznej)</li>
              </ul>
            </div>
          </div>
        </GrayPanel>

        <AttachmentsPanel onChangeAttachments={this.onChangeAttachments} showExtraText={this.props.districts[this.props.prefix].attachmentsToEpuapEnabled}/>

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

DecyzjeWZ.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(DecyzjeWZ),
);



// WEBPACK FOOTER //
// src/routes/eservices/DecyzjeWZ.js